<template>
<div id="WorkOrderView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div class="right-asset-tab-list purchase-order-right-tab">
        <div id="tabs" class="containerTab">
            <div class="tabs">
                <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">WO Details</a>
                <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity</a>
            </div>
            <div class="content" id="workorder-detail-tabs">
                <div v-show="activetab === 1" class="tabcontent">
                    <div class="list-view">
                        <div class="row form-group border-bottom pb-2">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                            <label class="col">#WO :</label>
                            <span class="col">{{titleCase(workOrderNoInfo)}}</span>
                        </div>
                        <div v-if="custPoNo != '' && assetRequired" class="row form-group border-bottom pb-2">
                            <!-- <label class="col"> <i class="hi-icon icon-flbill"></i> </label> -->
                            <label class="col">#PO :</label>
                            <span class="col">
                                <!-- <router-link title="View PO" target="_blank" class="color-blue" v-bind:to="{name: 'CustomerPurchaseOrderView',params:{id:custPoId}}">{{custPoNo}} </router-link> -->
                                {{custPoNo}}
                            </span>
                        </div>
                        <div class="row form-group border-bottom pb-2" v-if="assetRequired">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                            <label class="col">Customer :</label>
                            <span class="col">{{customerInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2" v-if="contractData.length > 0">
                            <!-- <span class="work-order-icon"> <i class="hi-icon fp-iconAgreement"> </i></span> -->
                            <label class="col">Contract :</label>
                            <span class="col">
                                <template v-if="contractData && contractData.length > 0">
                                    <span v-for="(contract, cntIndex) in contractData" :key="cntIndex">
                                            <router-link title="View Contract" target="_blank" class="color-blue" v-bind:to="{name: 'ContractView',params:{id:contract.contract_id}}">{{contract.ct_name}} | {{contract.ct_code}}  </router-link>
                                        <!-- <span class="customer-detail-rv"> {{contract.ct_name}} ( {{contract.ct_code}} ) ,</span> -->
                                    </span>
                                </template>
                                <template v-else> - </template>
                            </span>
                        </div>
                        <div class="row form-group border-bottom pb-2" v-if="assetRequired">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-fldelivery-truck"></i> </span> -->
                            <label class="col">Unit :</label>
                            <span class="col">{{assetInfo}}</span>
                        </div>
                      <div class="row form-group border-bottom pb-2" v-if="assetRequired">
                        <!-- <span class="work-order-icon"> <i class="hi-icon icon-fldelivery-truck"></i> </span> -->
                        <label class="col">Asset Pool :</label>
                        <span class="col">{{assetPoolInfo}}</span>
                      </div>
                        <div class="row form-group border-bottom pb-2" v-if="assetRequired">
                            <label class="col">Serial Number :</label>
                            <span class="col">{{serial_number}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2" v-if="assetRequired">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-fltime-saving"></i> </span> -->
                            <label class="col">Customer Unit No. :</label>
                            <span class="col">{{alias_number}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2" v-if="taskArr.length && taskArr[0].bill_id != null && !assetRequired">
                            <label class="col">Vendor Invoice :</label>
                            <span class="col"><router-link class="color-blue" v-bind:to="{name: 'BillView',params:{id:taskArr[0].bill_id}}" target="_blank">{{taskArr[0].voucher}}</router-link></span>
                        </div>
                        <div class="row form-group border-bottom pb-2" v-if="!assetRequired">
                            <label class="col">&nbsp;</label>
                            <template v-if="taskArr[0] && taskArr[0].bill_status != undefined && taskArr[0].bill_status != null">
                                <button v-if="canVerifyVendorInvoice && woStatusInfo.toLowerCase() != 'approved' && taskArr[0].bill_status.toLowerCase() == 'verified'" type="submit" :id="'unverifyInvoiceBtn'" v-on:click.prevent="verifyVendorInvoice(taskArr[0],0,'entered')" class="btn btn-tertiary pull-right mt-2 adjMarginRV"> Unverify </button>
                                <button v-if="canVerifyVendorInvoice && woStatusInfo.toLowerCase() != 'approved' && taskArr[0].bill_status.toLowerCase() == 'entered'" type="submit" :id="'verifyInvoiceBtn'" v-on:click.prevent="verifyVendorInvoice(taskArr[0],0,'verified')" class="btn btn-tertiary pull-right mt-2 adjMarginRV"> Verify </button>
                                <button v-if="(canUpdateVendorInvoice && woStatusInfo.toLowerCase() != 'approved' && (taskArr[0].bill_status.toLowerCase() == 'entered'))" type="submit" :id="'editInvoiceBtn'" v-on:click.prevent="createHeaderInvoice = true" class="btn btn-primary mr-2 pull-right mt-2 adjMarginRV"> <i class="fp-edit-icon"></i>  Edit </button>
                            </template>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-fltime-saving"></i> </span> -->
                            <label class="col">Status :</label>
                            <span class="col">{{woStatusInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-fltime-saving"></i> </span> -->
                            <label class="col">Approved By :</label>
                            <span class="col">{{approvedInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Approved Date :</label>
                            <span class="col">{{ workOrderObj.approvedAt }}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                            <label class="col">Open Date :</label>
                            <span class="col">{{openDateInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Close Date :</label>
                            <span class="col">{{closeDateInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-flplaceholder-filled-point"></i> </span> -->
                            <label class="col">Location :</label>
                            <span class="col">{{locationInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Requested Completion :</label>
                            <span class="col">{{requestCompInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">User :</label>
                            <span class="col">{{userInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Maintenance Type :</label>
                            <span class="col">{{maintenanceTypeInfo}}</span>
                        </div>
                      <template v-if="sectionArr && sectionArr.length">
                        <template v-for="(sc,sval) in sectionArr">
                          <template v-if="sc.read_on_wo != undefined && sc.read_on_wo.toLowerCase() == 'mandatory'">
                            <div class="row form-group border-bottom pb-2" :key="sval">
                              <template v-if="sc.section_code.toLowerCase() == 'dist'">
                                <label class="col">Odometer :</label>
                              </template>
                              <template v-else>
                                <label class="col">{{ sc.sectionName }} :</label>
                              </template>

                              <template v-if='addMiles==false'>
                                <span class="col">{{ sc.reading }}</span>
                              </template>
                              <template v-else>
                                    <span class="col">
                                        <input :class="sc.class" v-model="sc.reading" :id="'woMilesRead'+sval"
                                               :placeholder="sc.sectionName" name="woMiles"
                                               @keypress="isAmountCheck($event)">
                                    </span>
                              </template>
                            </div>
                          </template>
                        </template>
                      </template>

                      <template v-if="showSaveButton==true">
                        <div class="row form-group border-bottom pb-2" v-if='addMiles==true'>

                          <label class="col"></label>
                          <button type="submit" id="createReadingBtn" class="btn btn-primary adjMarginRV"
                                  v-on:click.prevent="saveMiles()">
                            <i class="fp-save"> </i> Save
                          </button>
                        </div>
                      </template>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Notes :</label>
                            <span class="col">{{woNotesInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Schedule Maintenance :</label>
                            <span class="col">{{scheduleMaintenanceInfo}}</span>
                        </div>

                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Agreed Date :</label>
                            <span class="col">{{agreedDateInfo}}</span>
                        </div>

                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Priority :</label>
                            <span class="col">{{priorityInfo}}</span>
                        </div>

                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Total Labor :</label>
                            <span class="col text-right">{{amountFormat(laborAmount)}}</span>
                        </div>

                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Total Part:</label>
                            <span class="col text-right">{{amountFormat(componentAmount)}}</span>
                        </div>

                        <!-- <div class="row form-group border-bottom pb-2">
                            <label class="col">Shop Supplies:</label>
                            <span class="col text-right">{{amountFormat(shopSupplies)}}</span>
                        </div>

                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Other Charges:</label>
                            <span class="col text-right">{{amountFormat(otherCharges)}}</span>
                        </div> -->

                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Sales Tax:</label>
                            <span class="col text-right">{{amountFormat(taxAmount)}}</span>
                        </div>

                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Total :</label>
                            <span class="col text-right">{{amountFormat(total)}}</span>
                        </div>
                    </div>

                </div>
                <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                    <div class="col-md-12 customer-view-main">
                        <div class="row">
                            <workorder-activity-log-list :activityLogVal="activityLogsTabValue"></workorder-activity-log-list>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section purchase-order-left-section">
        <template v-if="cantAccessPage === true">
            <div class="page-name asset-view-page-name purchase-order-title">
                <!-- Work Order View -->
                <div class="page-title" style="width:auto;"> {{titleCase(workOrderNoInfo) }} <span v-if="unitNumber != undefined && unitNumber != ''">({{ unitNumber }})</span></div>
                <div class="web-action-btn btn-groups">
                    <button type="button" v-if="canAddCrm" class="btn btn-secondary" v-on:click="crmSection()" >
                        <i class="fp-agreement"> </i> {{crmBtnTitle}}
                    </button>
                    <template v-if="!isCrmSection">
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <!-- As Work Order Invoice Generated From backend on Work Order Approve-->
                    <!-- <template v-if="woStatusInfo.toLowerCase() == 'approved' && taskArr.length > 0 && invoiceGenerated == 'false' && showBillBtn==true">
                        <button type="submit" id="generateInvoice" v-on:click="generateInvoice()" class="btn btn-tertiary" > <i class="fp-invoice"> </i> Generate Invoice</button>
                    </template> -->
                    <template v-if="assetRequired && taskArr.length > 0 && invoiceGenerated == 'true' && showBillBtn==true && invoice_id != null && invoice_id != ''">
                        <button type="submit" id="viewCustInvoice" v-on:click="viewCustomerInvoice()" class="btn btn-tertiary" > <i class="fp-invoice"> </i> Customer Invoice</button>
                    </template>
                    <button v-if="woType.toLowerCase() != 'multi unit'" type="submit" id="estimationApproval" v-on:click="createEstimate('customer')" class="btn btn-tertiary"> Customer Estimate</button>
                    <!-- <button type="submit" id="estimationRequired" v-on:click="createEstimate('vendor')" class="btn btn-tertiary">  Vendor Estimate</button> -->
                    <template v-if="woStatusInfo.toLowerCase() == 'approved' && taskArr.length > 0">
                        <button type="submit" id="printWithoutCost" v-on:click="print('no-cost')" class="btn btn-secondary" > <i class="fp-print"> </i> Preview Without Cost
                        </button>
                        <!-- If user is not technician-->
                        <template v-if="userRole != '' && userRole.toLowerCase() != 'technician'">
                            <button type="submit" id="printWithCost" v-on:click="print('cost')" class="btn btn-secondary" > <i class="fp-print"> </i> Preview With Cost
                            </button>
                        </template>
                    </template>
                    <button v-if="woStatusInfo.toLowerCase() != 'approved' && taskArr.length > 0" type="button" id="estimationApproval" v-on:click="print('open')" class="btn btn-secondary" > <i class="fp-print"> </i> Preview</button>
                    <!-- <button type="submit" id="estimationApproval" v-on:click="createPurchaseOrder('vendor')" class="btn btn-primary"> <i class="fp-submit"> </i> Purchase Order</button> -->
                    <button v-if="woStatusInfo.toLowerCase() != 'approved' && woStatusInfo.toLowerCase() != 'closed' && taskArr.length > 0" type="button" id="closeWOItemBtn" v-on:click="showmodel()" class="btn btn-secondary" > Close WO Items</button>
                    <button type="button" id="editWorkOrderBtn" v-if="woStatusInfo.toLowerCase() != 'approved' && (poStatus != 'closed' || woType != 'multi unit')" v-on:click="editWorkOrder()" class="btn btn-primary"><i class="fp-edit-icon"></i> Edit</button>
                    <button type="button" id="approveWorkOrderBtn" v-if="canApproveWO && woStatusInfo.toLowerCase() == 'closed'" v-on:click="approveWorkOrder()" class="btn btn-primary"> Approve</button>
                    <button v-if="canApproveWO && woStatusInfo.toLowerCase() == 'approved' && workOrderObj.lockStatus == 'false'" type="button" id="disapproveBtn" v-on:click="disapproveWo()" class="btn btn-warning" > Disapprove</button>
                    <button type="button" id="editWorkOrderBtn" v-if="$route.query.batch != undefined" v-on:click="nextWorkOrder()" class="btn btn-primary"> Next</button>
                    <button v-if="woType.toLowerCase() == 'multi unit' && taskArr.length > 0 && taskArr[0].bill_id == null" type="button" id="vendor_invoice" v-on:click="createHeaderInvoice = true" class="btn btn-secondary" > Vendor Invoice</button>
                    <button type="button" class="btn btn-secondary" v-on:click.prevent="backWorderList" >
                        <i class="fp-back"> </i>    Back
                    </button>
                    </template>

                    <!-- <template v-if="canListWorkOrder == true && !$route.query.from">
                        <router-link class="btn btn-secondary" v-bind:to="{name: 'WorkOrderList'}"> <i class="fp-back"></i> Back</router-link>
                    </template>
                    <template v-if="$route.query.from == 'cust_estimate'">
                        <router-link class="btn btn-secondary" v-bind:to="{name: 'EstimateMainList'}"> <i class="fp-back"></i> Back</router-link>
                    </template>
                    <template v-if="$route.query.from == 'cust_po_list'">
                        <router-link class="btn btn-secondary" v-bind:to="{name: 'PurchaseOrderAllList',query:{from:'cust_po_wo'}}"> <i class="fp-back"></i> Back</router-link>
                    </template> -->

                </div>
                <div class="mobile-action-btn elipse-btn">
                    <button type="submit" id="editWorkOrderBtn" v-if="woStatusInfo.toLowerCase() != 'approved'" v-on:click="editWorkOrder()" class="btn btn-primary"><i class="fp-edit-icon"></i> Edit</button>
                    <!-- <template v-if="canListWorkOrder == true && !$route.query.from">
                        <router-link class="btn btn-secondary" v-bind:to="{name: 'WorkOrderList'}"> <i class="fp-back"></i> Back</router-link>
                    </template>
                    <template v-if="$route.query.from == 'cust_estimate'">
                        <router-link class="btn btn-secondary" v-bind:to="{name: 'EstimateMainList'}"> <i class="fp-back"></i> Back</router-link>
                    </template>
                    <template v-if="$route.query.from == 'cust_po_list'">
                        <router-link class="btn btn-secondary" v-bind:to="{name: 'PurchaseOrderAllList',query:{from:'cust_po_wo'}}"> <i class="fp-back"></i> Back</router-link>
                    </template> -->
                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="backWorderList" >
                        <i class="fp-back"> </i>    Back
                    </button>


                    <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="true" v-on:click.prevent="myFunction">
                        <i class="fp-ellipsis-v"></i>
                    </button>
                    <div id="myDropdown" class="dropdown-content">
                        <ul>
                            <!-- As Work Order Invoice Generated From backend on Work Order Approve-->
                            <!-- <li v-if="woStatusInfo.toLowerCase() == 'approved' && taskArr.length > 0 && invoiceGenerated == 'false' && showBillBtn==true">
                                <router-link id="generateInvoice" v-on:click="generateInvoice()"> Generate Invoice</router-link>
                            </li> -->
                            <li>
                                <a id="estimationApproval" v-on:click="createEstimate('customer')"> Customer Estimate</a>
                            </li>
                            <!-- <li>
                                <a id="estimationRequired" v-on:click="createEstimate('vendor')">  Vendor Estimate</a>
                            </li> -->
                            <!-- <li>
                                <a id="estimationApproval" v-on:click="createPurchaseOrder('vendor')"> Purchase Order</a>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
          <div class="container-fluid">
            <div id="workorder-detail work-order-view-top" class="admin-page-content work-order-view">
              <div class="wo-vendorinv-form" v-if="createHeaderInvoice">
                <vendor-invoice-form :id="'createInvoiceFromWOPO'" class="wo-vendorinv-panel"
                                     v-if="createHeaderInvoice" :poInvoiceFromWO="'sublet_invoice'"
                                     :poDataFromWO="taskArr[0].po_data_from_wo"></vendor-invoice-form>
              </div>
              <div id="tabs" class="containerTab mt-3">
                <div class="tabs">
                  <a v-on:click="changeTabStatus(1)" id="line_details" :class="'tabcontent '+line_details">Line Detail</a>
                  <a v-on:click="changeTabStatus(2)" id="gl_details" :class="'tabcontent '+gl_details">GL Details</a>
                  <a v-on:click="changeTabStatus(3)" id="adjustment" :class="'tabcontent '+adjustment">Adjustment</a>
                </div>
              </div>
              <template v-if="!isCrmSection">
                <div v-show="detail_tab === 1" class="tabcontent">
                    <section class="internal-container border-top-table-fl">
                      <template v-if="taskArr.length == 0">
                        <div class="lineitem-main-section">
                          <h4 class="mb-0">No Line Item Added</h4>
                        </div>
                      </template>
                      <template v-else>
                        <div class="form-row">
                          <table aria-describedby="table" class="table table-sm work-order-accordion"
                                 id="workOrder-table">
                            <thead>
                            <th hidden></th>
                              <tr v-for="(task, index) in taskArr" :key="index"> <!--Accordion 1 content-->
                              <td class="accordion-row">
                                <table aria-describedby="table" class="table table-sm">
                                  <thead>
                                  <th hidden></th>
                                  <tr data-toggle="collapse" :data-target="'#demo'+index" class="accordion-toggle"
                                      :id="'item'+task.woiId">
                                    <td>
                                      <div class="custom-checkbox">
                                        <label class="checkbox-custom">
                                          <template v-if="lineSequence == 0">
                                            Line Item {{ index + 1 }}
                                          </template>
                                          <template v-else>
                                            Line Item {{ task.line_number }}
                                          </template>
                                          <!-- <input data-v-3c5d4e02="" type="checkbox" id="itemIndex0" name="estimation_selection0">  -->
                                          <input type="checkbox" :id="'itemIndex'+index"
                                                 :name="'estimation_selection'+index"
                                                 @change="selectionForEstimation($event,task,index)"
                                                 v-model="task.itemSelection">
                                          <span class="checkmark"></span>
                                        </label>
                                      </div>
                                    </td>
                                    <td v-if="!assetRequired">
                                      <label> Unit No: </label>
                                      <span class="label" v-if="task.unit_no != ''"> {{ task.unit_no }} </span>
                                    </td>
                                    <td>
                                      <label> VMRS: </label>
                                      <span class="label"
                                            v-if="task.component_category_id != null"> {{
                                          task.component_category_id.text
                                        }} </span>
                                      <span class="label" v-else> {{ task.component_category_id }} </span>
                                    </td>
                                    <td v-if="task.program_id != null">
                                      <label> Program: </label>
                                      <span class="label" v-if="task.program_id != null"> {{
                                          task.program_id.text
                                        }} </span>
                                    </td>
                                    <td>
                                      <label> Status: </label>
                                      <span class="label" v-if="task.woistatus != '-'"> {{
                                          task.woistatus.text
                                        }} </span>
                                      <span class="label" v-else> {{ task.woistatus }} </span>
                                    </td>
                                    <td>
                                      <label> Sublet: </label>
                                      <span class="sublet-status-yes" v-if="task.issublet == 1"></span>
                                      <span class="sublet-status-no" v-else></span>
                                      <span class="label" v-if="task.issublet == 1"> Yes </span>
                                      <span class="label" v-else> No </span>
                                    </td>
                                    <td class="accordion-down-arrow"><i class="fp-right-arrow"></i></td>
                                  </tr>
                                  <tr>
                                    <td colspan="5" style="padding:0;border-top:0;">
                                      <div :id="'demo'+index" class="mt-5 pl-3 pr-3 collapse">
                                        <div class="row list-view">
                                          <div class="col-md-4 form-group border-right">
                                            <!-- <div class="col-md-6 form-group border-right">     -->
                                            <div class="form-row row-cols-md-2 row-cols-1">
                                              <label class="col"> Task :</label>
                                              <span class="col label"
                                                    v-if="task.taskid != '-'"> {{ task.taskid.text }} </span>
                                              <span class="col label" v-else> {{ task.taskid }} </span>
                                            </div>
                                            <div class="form-row row-cols-md-2 row-cols-1">
                                              <label class="col"> Reason: </label>
                                              <span class="col label"
                                                    v-if="task.wi_reason_id != '-'"> {{
                                                  task.wi_reason_id.text
                                                }} </span>
                                              <span class="col label" v-else> {{ task.wi_reason_id }} </span>
                                            </div>
                                            <div class="form-row row-cols-md-2 row-cols-1">
                                              <label class="col"> Billable: </label>
                                              <span class="col label"
                                                    v-if="task.billable_code != '-' && task.billable_code != null"> {{
                                                  task.billable_code.text
                                                }} </span>
                                              <span class="col label" v-else> {{ task.billable_code }} </span>
                                            </div>
                                            <div class="form-row row-cols-md-2 row-cols-1">
                                              <label class="col"> Warranty: </label>
                                              <span class="col label" v-if="task.warranty && task.warranty.value"> <router-link
                                                  v-bind:to="'/warranty/view/'+task.warranty.value+'?wo='+$route.params.id">{{
                                                  task.warranty.text
                                                }}</router-link> </span>
                                              <span class="col label" v-else> - </span>
                                            </div>
                                          </div>
                                          <div class="col-md-5 form-group border-right">
                                            <!-- <div class="col-md-6 form-group">     -->
                                            <div class="form-row row-cols-md-2 row-cols-1">
                                              <label class="col"> Part Fail: </label>
                                              <span class="col label"
                                                    v-if="task.defect_id != '-'"> {{ task.defect_id.text }} </span>
                                              <span class="col label" v-else> {{ task.defect_id }} </span>
                                            </div>
                                            <div class="form-row row-cols-md-2 row-cols-1">
                                              <label class="col"> Vendor: </label>
                                              <span class="col label"
                                                    v-if="task.vendorid != '-'"> {{ task.vendorid.text }} </span>
                                              <span class="col label" v-else> {{ task.vendorid }} </span>
                                            </div>
                                            <div class="form-row row-cols-md-2 row-cols-1">
                                              <label class="col"> PO: </label>
                                              <span class="col label"
                                                    v-if="task.purchaseorderid != '-'"> {{
                                                  task.purchaseorderid.text
                                                }} </span>
                                              <span class="col label" v-else> {{ task.purchaseorderid }} </span>
                                            </div>
                                            <div class="form-row row-cols-md-2 row-cols-1">
                                              <label class="col"> SRT: </label>
                                              <span class="col label"
                                                    v-if="task.std_repair_time != '-' && task.std_repair_time != '0'"> {{
                                                  task.std_repair_time
                                                }} </span>
                                              <span class="col label" v-else> - </span>
                                            </div>
                                            <div class="form-row row-cols-md-2 row-cols-1">
                                              <label class="col"> ETC: </label>
                                              <span class="col label"
                                                    v-if="task.est_repair_time != '-' && task.est_repair_time != '0'"> {{
                                                  task.est_repair_time
                                                }} </span>
                                              <span class="col label" v-else> - </span>
                                            </div>
                                          </div>
                                          <div class="col-md-3 form-group"
                                               v-if="task.issublet == 1 || (task.claim_number != null && task.claim_number != '')">
                                            <!-- <div class="enrich-transition-number basic-form-container sublet-work-order-section">
                                                <div data-v-3c5d4e02="" class="sublet-amnt-left-section">
                                                  <label class="required"> Sublet Amount </label>
                                                  <input type="text" id="subletAmount0" class="form-control">
                                                </div>
                                                <button type="submit" id="subletAmountBtn" class="btn btn-success btn-primary nextBtn btn-lg has-tooltip" data-original-title="null">
                                                  <i class="hi-icon icon-flSave"></i> Save
                                                </button>
                                                <div id="subletError0" class="d-error"></div>
                                              </div> -->
                                            <div class="form-row"
                                                 v-if="task.issublet == 1 && task.sublet_amount != null">
                                              <label class="col"> Sublet Amount: </label>
                                              <span class="col label"> {{ amountFormat(task.sublet_amount) }} &nbsp;&nbsp;<a
                                                  href="javascript:void(0)" v-if="!task.purchaseorderid.value"
                                                  class="fp-edit"
                                                  v-on:click="updateAmountBlock(index)"></a></span>
                                            </div>
                                            <div :id="'subletAmountBlock'+index"
                                                 v-if="task.issublet == 1 && task.sublet_amount == null && !task.purchaseorderid.value">
                                              <label class="require"> Sublet Amount </label>
                                              <div class="form-row">
                                                <div class="col">
                                                  <input v-model="task.inset_sublet_amount" type="text"
                                                         :id="'subletAmount'+index" class="form-control">
                                                </div>
                                                <div class="col">
                                                  <button type="submit" id="subletAmountBtn"
                                                          v-on:click="updateSubletAmount(task,index)"
                                                          class="btn btn-primary">
                                                    <i class="fp-save"></i> Save
                                                  </button>
                                                </div>
                                              </div>
                                              <div class="field-error" :id="'subletError'+index"></div>
                                            </div>
                                            <div class="form-row"
                                                 v-if="task.claim_number != null && task.claim_number != ''">
                                              <label class="col"> Warranty Claim: </label>
                                              <span class="col label"> {{ task.claim_number }}
                                                <!-- &nbsp;&nbsp;<a href="javascript:void(0)" v-if="task.claim_number != ''" class="fp-edit" v-on:click="updateClaimAmountBlock(task.claim_id)"></a> -->
                                                                    </span>
                                            </div>
                                            <div class="form-row" v-if="!assetRequired">
                                              <label class="col"> Serial Number: </label>
                                              <span class="col label">{{ task.serial_number }}</span>
                                            </div>
                                            <div class="form-row" v-if="!assetRequired">
                                              <label class="col"> Customer Unit No.: </label>
                                              <span class="col label">{{ task.alias_number }}</span>
                                            </div>
                                          </div>

                                          <!-- <template>
                                                <div class="wo-vendorinv-form">
                                                    <warranty-claim-form id="warranty-claim-form" class="wo-vendorinv-panel" v-if="create_warranty_claim" :itemId="task.woiId" :claimId="task.claim_id" :itemData="task.warranty_from_wo" :flag="setFlagClaim"></warranty-claim-form>
                                                </div>
                                            </template> -->
                                        </div>
                                        <div class="web-action-btn btn-groups">
                                          <button v-if="!create_warranty_claim && !task.claim_id" type="submit"
                                                  class="btn btn-secondary" v-on:click.prevent="addClaim(index)">
                                            <i class="fp-add"> </i> Add Warranty Claim
                                          </button>
                                        </div>
                                        <hr class="light-hr"/>
                                        <div class="form-row row-cols-md-3 row-cols-1">
                                          <div class="col form-group d-flex">
                                            <!-- <span class="work-order-icon pull-left"> <i class="fp-contracts complain-icon"></i></span> -->
                                            <div class="work-order-section pull-left pl-4">
                                              <h6 class="mb-0 font-bold"> Complaint: </h6>
                                              <p class="mb-0" v-if="task.woicomplaint != ''"> {{
                                                  task.woicomplaint
                                                }}</p>
                                              <p class="mb-0" v-else> NA</p>
                                            </div>
                                          </div>
                                          <div class="col form-group d-flex">
                                            <!-- <span class="work-order-icon pull-left"> <i class="fp-profiles cause-icon"></i></span> -->
                                            <div class="work-order-section pull-left pl-4">
                                              <h6 class="mb-0 font-bold"> Cause: </h6>
                                              <p class="mb-0" v-if="task.woicause != ''"> {{ task.woicause }}</p>
                                              <p class="mb-0" v-else> NA</p>
                                            </div>
                                          </div>
                                          <div class="col form-group">
                                            <!-- <span class="work-order-icon pull-left"> <i class="fp-agreement correction-icon"></i></span> -->
                                            <div class="work-order-section pl-4">
                                              <h6 class="mb-0 font-bold"> Correction: </h6>
                                              <p class="mb-0" v-if="task.woicorrection != ''"> {{
                                                  task.woicorrection
                                                }}</p>
                                              <p class="mb-0" v-else> NA</p>
                                            </div>
                                          </div>

                                        </div>
                                        <div class="col form-group d-flex">
                                          <div class="work-order-section pl-4">
                                            <div class="web-action-btn btn-groups">
                                              <button type="button" class="btn btn-primary"
                                                      v-on:click.prevent="showCommentsEditModal(task.woiId,task.woicomplaint,task.woicause,task.woicorrection)">
                                                <i class="fp-edit-icon"> </i> Edit
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <hr class="light-hr"/>
                                        <div class="form-row row-cols-md-4 row-cols-1">
                                          <div class="col form-group">
                                            <div class="vendor-info customer-estimate">
                                              <p class="font-bold mb-2"> Customer Estimate: <span
                                                  v-if="task.cust_estimate_no"><router-link class="color-blue"
                                                                                            v-bind:to="{name:'CustomerEstimateView',params:{id:task.cust_est_id}}"
                                                                                            target="_blank">#{{
                                                  task.cust_estimate_no
                                                }} </router-link> </span><span
                                                  v-else>NA</span></p>
                                              <span v-if="task.cust_estimate_no" class="popover-icon">
                                                                        <label for="chkCustomerEst"
                                                                               class="fa fa-info-circle"></label>
                                                                        <input type="checkbox" id="chkCustomerEst"
                                                                               class="d-none estcust-checkbox"/>
                                                                        <div class="popover">
                                                                        <div class="arrow"></div>
                                                                        <h3 class="popover-header">Customer Estimate</h3>
                                                                        <div class="popover-body">
                                                                            <p class="mb-2"> Estimate Sent Status: <span>{{
                                                                                titleCase(task.cust_sent_status)
                                                                              }}</span>
                                                                            </p>
                                                                            <p class="mb-2"> Part Amount:
                                                                                <span>{{
                                                                                    task.cust_estimate_part_amount
                                                                                  }}</span>
                                                                            </p>
                                                                            <p> Labor Amount:
                                                                                <span>{{
                                                                                    task.cust_estimate_labor_amount
                                                                                  }}</span>
                                                                            </p>
                                                                        </div>
                                                                        </div>
                                                                    </span>
                                            </div>
                                          </div>
                                          <div class="col form-group">
                                            <div class="vendor-info vendor-po">
                                              <p class="font-bold mb-2"> Vendor PO:
                                                <span v-if="task.po_no">
                                                                            <router-link class="color-blue"
                                                                                         v-bind:to="{name:'VendorPurchaseOrderView',params:{id:task.po_id}}"
                                                                                         target="_blank">#{{
                                                                                task.po_no
                                                                              }} </router-link>
                                                                        </span>
                                                <span v-else>NA</span>
                                                &nbsp;&nbsp;
                                                <span v-if="task.po_no" class="popover-icon">
                                                                            <label for="chkVendorPO"
                                                                                   class="fa fa-info-circle"></label>
                                                                            <input type="checkbox" id="chkVendorPO"
                                                                                   class="d-none vendorpo-checkbox"/>
                                                                            <div class="popover">
                                                                                <div class="arrow"></div>
                                                                                <h3 class="popover-header">Vendor PO</h3>
                                                                                <div class="popover-body">
                                                                                    <p class="mb-2"> PO Amount:
                                                                                        <span>{{ task.po_total }}</span>
                                                                                    </p>
                                                                                    <p class="mb-2"> Vendor:
                                                                                        <span>{{
                                                                                            task.po_vendor
                                                                                          }}</span>
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </span>
                                              </p>
                                              <button
                                                  v-if="(canUpdateVendorPO && assetRequired && task.po_no && task.issublet == 1 && task.woistatus.value != 'closed' && task.po_status != 'closed')"
                                                  type="submit" :id="'editPOBtn'+index"
                                                  v-on:click.prevent="editVendorPO(task.po_id,index)"
                                                  class="btn btn-primary pull-right">
                                                <i class="fp-edit-icon"></i> Edit
                                              </button>
                                            </div>
                                          </div>
                                          <div class="col form-group">
                                            <div class="vendor-info vendor-estimate">
                                              <p class="font-bold mb-2"> Vendor Estimate: <span
                                                  v-if="task.vendor_estimate_no"> <router-link class="color-blue"
                                                                                               v-bind:to="{name: 'VendorEstimateView',params:{id:task.vendor_est_id}}"
                                                                                               target="_blank">#{{
                                                  task.vendor_estimate_no
                                                }}</router-link> </span><span
                                                  v-else>NA</span></p>
                                              <span v-if="task.vendor_estimate_no" class="popover-icon">
                                                                        <label for="chkVendorEst"
                                                                               class="fa fa-info-circle"></label>
                                                                        <input type="checkbox" id="chkVendorEst"
                                                                               class="d-none estvendor-checkbox"/>
                                                                        <div class="popover">
                                                                            <div class="arrow"></div>
                                                                            <h3 class="popover-header">Vendor Estimate</h3>
                                                                            <div class="popover-body">
                                                                            <p class="mb-2"> Estimate Sent Status:
                                                                                <span>{{ titleCase(task.sent_status) }}</span>
                                                                            </p>
                                                                            <p class="mb-2"> Part Amount:
                                                                                <span> {{
                                                                                    task.vendor_estimate_part_amount
                                                                                  }}</span>
                                                                            </p>
                                                                            <p class="mb-2"> labor Amount:
                                                                                <span> {{
                                                                                    task.vendor_estimate_labor_amount
                                                                                  }}</span>
                                                                            </p>
                                                                        </div>
                                                                        </div>
                                                                    </span>
                                            </div>
                                          </div>
                                          <div class="col form-group">
                                            <div class="vendor-info vendor-invoice">
                                              <!-- Generate Vendor Invoice Button -->
                                              <template v-if="task.bill_id">
                                                <p class="font-bold mb-2"> Vendor Invoice:
                                                  <span v-if="task.bill_id">
                                                    <router-link class="color-blue"
                                                                  v-bind:to="{name: 'BillView',params:{id:task.bill_id}}"
                                                                  target="_blank">#{{
                                                        task.voucher
                                                      }}</router-link>
                                                    &nbsp;&nbsp;
                                                    <span v-if="task.bill_id"
                                                          class="popover-icon">
                                                        <label for="chkVendorInvoice"
                                                                class="fa fa-info-circle"></label>
                                                        <input type="checkbox"
                                                                id="chkVendorInvoice"
                                                                class="d-none vendorinv-checkbox"/>
                                                        <div class="popover">
                                                            <div class="arrow"></div>
                                                            <h3 class="popover-header">Vendor Invoice</h3>
                                                            <div class="popover-body">
                                                            <p class="mb-2"> Status:
                                                                <span>{{
                                                                    titleCase(task.bill_status)
                                                                  }}</span>
                                                            </p>
                                                            <p class="mb-2"> Vendor Invoice Amount:
                                                                <span>{{
                                                                    task.bill_amount
                                                                  }}</span>
                                                            </p>
                                                        </div>
                                                        </div>
                                                    </span>
                                                </span>
                                                <span v-else>NA</span>
                                                </p>
                                                <!-- Verify Invoice Button if status is Entered-->
                                                <template
                                                    v-if="task.bill_status != undefined && task.bill_status != null && assetRequired">
                                                  <button
                                                      v-if="canVerifyVendorInvoice && task.woistatus.value != 'closed' && task.bill_status.toLowerCase() == 'verified'"
                                                      type="button" :id="'unverifyInvoiceBtn'+index"
                                                      v-on:click.prevent="verifyVendorInvoice(task,index,'entered')"
                                                      class="btn btn-tertiary pull-right mt-2"> Unverify
                                                  </button>
                                                  <button
                                                      v-if="canVerifyVendorInvoice && task.woistatus.value != 'closed' && task.bill_status.toLowerCase() == 'entered'"
                                                      type="button" :id="'verifyInvoiceBtn'+index"
                                                      v-on:click.prevent="verifyVendorInvoice(task,index,'verified')"
                                                      class="btn btn-tertiary pull-right mt-2"> Verify
                                                  </button>
                                                  <button
                                                      v-if="(canUpdateVendorInvoice && task.woistatus.value != 'closed' && (task.bill_status.toLowerCase() == 'entered'))"
                                                      type="button" :id="'editInvoiceBtn'+index"
                                                      v-on:click.prevent="generatePOInvoice(task,index)"
                                                      class="btn btn-primary mr-2 pull-right mt-2"><i
                                                      class="fp-edit-icon"></i> Edit
                                                  </button>
                                                  <button
                                                      v-if="(canUpdateVendorInvoice && task.woistatus.value != 'closed' && (task.bill_status.toLowerCase() == 'entered'))"
                                                      type="button" :id="'deleteInvoiceBtn'+index"
                                                      v-on:click.prevent="billDelete(task,index)"
                                                      class="btn btn-danger mr-2 pull-right mt-2"> Delete
                                                  </button>
                                                </template>

                                              </template>
                                              <template v-else>
                                                <p class="font-bold mb-2"> Vendor Invoice:
                                                  <template
                                                      v-if="canAddVendorInvoice && task.issublet == 1 && task.po_no && assetRequired">
                                              <span><a href="javascript:void(0);" :id="'generateInvoice'+index"
                                                       class="color-blue"
                                                       v-on:click.prevent="generatePOInvoice(task,index)"> Upload</a></span>
                                                  </template>
                                                  <template v-else>
                                                    <span>NA</span>
                                                  </template>
                                                </p>
                                              </template>
                                            </div>
                                          </div>
                                        </div>
                                        <template v-if="canAddVendorInvoice || canUpdateVendorInvoice">
                                          <div class="wo-vendorinv-form"
                                               v-if="task.issublet == 1 && task.create_vendor_invoice == 1">
                                            <vendor-invoice-form :id="'createInvoiceFromWOPO'+index"
                                                                 class="wo-vendorinv-panel"
                                                                 v-if="task.create_po_invoice"
                                                                 :poInvoiceFromWO="task.po_invoice_from_wo"
                                                                 :poDataFromWO="task.po_data_from_wo">
                                            </vendor-invoice-form>
                                          </div>
                                        </template>
                                        <template>
                                          <div class="wo-vendorinv-form" v-if="task.create_warranty_claim">
                                            <warranty-claim-form id="warranty-claim-form"
                                                                 class="wo-vendorinv-panel additionClassTop"
                                                                 :itemId="task.woiId" :claimId="task.claim_id"
                                                                 :itemData="task.warranty_from_wo"
                                                                 :flag="setFlagClaim"
                                                                 :warrantyData="task.warranty"
                                                                 :workOrderId="work_order_id"
                                                                 :workOrderOpenDate="openDateInfo"></warranty-claim-form>
                                          </div>
                                        </template>
                                        <hr class="light-hr"/>
                                        <div class="part-table">
                                          <h5 class="color-blue font-bold"
                                              v-if="task.billable_code != null && task.billable_code.value != undefined && task.billable_code.value == 'S' && task.inv_line_pst_amount != 0">
                                            <i class="fp-service"></i> Parts ({{
                                              amountFormat(task.component_amount)
                                            }} +
                                            {{ amountFormat(task.inv_line_pst_amount) }} = {{
                                              amountFormat(task.taxamout)
                                            }})
                                          </h5>
                                          <h5 class="color-blue font-bold" v-else><i class="fp-service"></i> Parts (
                                            {{ amountFormat(task.taxamout) }})</h5>
                                          <div class="table-responsive-sm">
                                            <table aria-describedby="table"
                                                   class="table table-sm table-bordered font-1">
                                              <thead>
                                              <tr class="table-primary">
                                                <th> Part Name</th>
                                                <th> Description</th>
                                                <th class="text-right"> Is Issued ?</th>
                                                <th class="text-right"> Quantity</th>
                                                <th class="text-right" v-show="canViewWoSummary == true"> Rate</th>
                                                <th class="text-right" v-show="canViewWoSummary == true"> Total</th>
                                              </tr>
                                              </thead>
                                              <tbody>
                                              <template v-if="task.hasComponent === true">
                                                <tr v-for="(comp, componentIndex) in componentArr"
                                                    :key="componentIndex">
                                                  <template v-if="comp.service_task_id.index == index">
                                                    <td> {{ comp.compid.text }}</td>
                                                    <td> {{ comp.compdescription }}</td>
                                                    <td class="text-right" v-if="comp.is_issued == 1"> Yes</td>
                                                    <td class="text-right" v-else> No</td>
                                                    <td class="text-right"> {{ comp.compquantity }} Qty</td>
                                                    <td class="text-right" v-show="canViewWoSummary == true">
                                                      {{ amountFormat(comp.compcost) }}
                                                    </td>
                                                    <td class="text-right" v-show="canViewWoSummary == true">
                                                      {{ amountFormat(comp.compsubtotal) }}
                                                    </td>
                                                  </template>
                                                </tr>
                                              </template>
                                              <template v-else>
                                                <td colspan="5" class="no-data-field"> No Part Available</td>
                                              </template>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                        <hr class="light-hr"/>
                                        <div class="labor-table">
                                          <h5 class="color-blue font-bold"><i class="fp-labor-man"></i> Labor
                                            ({{ amountFormat(task.labor_amount) }})</h5>
                                          <div class="table-responsive-sm">
                                            <table aria-describedby="table"
                                                   class="table table-sm table-bordered font-1">
                                              <thead>
                                              <tr class="table-primary">
                                                <th> Technician</th>
                                                <th> Description</th>
                                                <th class="text-right"> Hour</th>
                                                <th class="text-right" v-show="canViewWoSummary == true"> Rate</th>
                                                <th class="text-right" v-show="canViewWoSummary == true"> Total</th>
                                              </tr>
                                              </thead>
                                              <tbody>
                                              <template v-if="task.hasLabor === true">
                                                <tr v-for="(labor, laborIndex) in laborArr" :key="laborIndex">
                                                  <template v-if="labor.service_task_id.index == index">
                                                    <td><span class="labor-name-wo"> </span> <span
                                                        v-if="labor.laborid != null">{{ labor.laborid.text }}</span>
                                                      <span
                                                          v-else>-</span></td>
                                                    <td> {{ labor.labordescription }}</td>
                                                    <td class="text-right"> {{
                                                        parseFloat(labor.laborhours).toFixed(2)
                                                      }}
                                                      Hrs
                                                    </td>
                                                    <td class="text-right" v-show="canViewWoSummary == true">
                                                      {{ amountFormat(labor.laborhourrate) }}
                                                    </td>
                                                    <td class="text-right" v-show="canViewWoSummary == true">
                                                      {{ amountFormat(labor.laborsubtotal) }}
                                                    </td>
                                                  </template>
                                                </tr>
                                              </template>
                                              <template v-else>
                                                <tr>
                                                  <td colspan="5" class="no-data-field"> No Labor Available</td>
                                                </tr>
                                              </template>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                        <hr class="light-hr"/>
                                        <div class="labor-table">
                                          <h5 class="color-blue font-bold"><i class="fp-log-file-format"></i> Detail
                                            Time
                                            Log
                                          </h5>
                                          <div class="table-responsive-sm">
                                            <table aria-describedby="table"
                                                   class="table table-sm table-bordered font-1">
                                              <thead>
                                              <tr class="table-primary">
                                                <th> Technician</th>
                                                <th> Start Time</th>
                                                <th> End Time</th>
                                                <th> Duration</th>
                                              </tr>
                                              </thead>
                                              <tbody>
                                              <template v-if="task.log_found == 1">
                                                <template v-for="(laborHour, laborHourIndex) in laborHourArr">
                                                  <tr v-if="laborHour.service_task_index == index"
                                                      :key="laborHourIndex">
                                                    <td><span class="labor-name-wo"> </span> <span
                                                        v-if="laborHour.labor_name != null">{{
                                                        laborHour.labor_name
                                                      }}</span>
                                                      <span v-else>-</span></td>
                                                    <td> {{ laborHour.start_time }}</td>
                                                    <td> {{ laborHour.end_time }}</td>
                                                    <td> {{ laborHour.duration }}</td>
                                                  </tr>
                                                </template>
                                              </template>
                                              <template v-else>
                                                <tr>
                                                  <td colspan="4" class="no-data-field"> No Time Log Available</td>
                                                </tr>
                                              </template>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                        <!-- <hr class="light-hr"/> -->
                                        <!-- <div class="workorder-activity-section comment-section-wo">
                                              <h5 class="color-blue font-bold"> <i class="fp-faq"></i> Comments </h5>
                                              <ul class="comment-box">
                                                  <template v-if="task.hasComment=== true">
                                                      <template v-for="(comment,commentIndex) in commentArr">
                                                          <template v-if="comment.service_task_id.index == index">
                                                              <li :key="commentIndex" class="work-order-list">
                                                                  <span class="labor-icon"> {{ comment.wocBy.substring(0,2).toUpperCase() }} </span>
                                                                  <div class="comment-details">
                                                                      <div class="comment-dec"><span class="user">{{comment.wocBy}}</span>({{comment.wocType.text}}) <span>{{comment.wocAt}}</span> </div>
                                                                      <p>{{comment.woc}}</p>
                                                                  </div>
                                                              </li>
                                                          </template>
                                                      </template>
                                                  </template>
                                                  <template v-else>
                                                      <li> <p class="no-data-field">No Comment Available</p></li>
                                                  </template>
                                              </ul>
                                          </div> -->
                                        <!-- Line Item Wise GL-->
                                        <!-- <template v-if="canViewGL && task.woistatus.value == 'closed'">
                                          <hr class="light-hr"/>
                                          <div class="labor-table">
                                            <h5 class="color-blue font-bold"><i class="fp-accounting"></i> General
                                              Ledger
                                            </h5>
                                            <div class="table-responsive-sm">
                                              <table aria-describedby="table"
                                                     class="table table-sm table-bordered font-1">
                                                <thead>
                                                <tr class="table-primary">
                                                  <th> Account</th>
                                                  <th class="text-right"> Debit</th>
                                                  <th class="text-right"> Credit</th>
                                                  <th class="text-right"> Amount</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <template
                                                    v-if="task.general_ledger != undefined && task.general_ledger.length">
                                                  <template v-for="(gl, glIndex) in task.general_ledger">
                                                    <tr v-if="gl.service_task_index == index" :key="glIndex">
                                                      <template v-if="gl.account_description == 'Total'">
                                                        <td class="text-right">{{ gl.account_description }}</td>
                                                      </template>
                                                      <template v-else>
                                                        <td>{{ gl.account_description }}</td>
                                                      </template>
                                                      <td class="text-right"> {{ gl.debit }}</td>
                                                      <td class="text-right"> {{ gl.credit }}</td>
                                                      <td class="text-right"> {{ gl.journal_amount }}</td>
                                                    </tr>
                                                  </template>
                                                </template>
                                                <template v-else>
                                                  <tr>
                                                    <td colspan="4" class="no-data-field"> No General Ledger Available
                                                    </td>
                                                  </tr>
                                                </template>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </template> -->
                                      </div>
                                    </td>
                                  </tr>
                                  </thead>
                                </table>
                              </td>
                            </tr>  <!--Accordion 1 content-->
                            </thead>
                          </table>
                        </div>
                        <template>
                          <div>
                            <div class="modal fade" id="updateWorkOrderItemFieldModal" tabindex="-1" role="dialog"
                                 aria-labelledby="updateWorkOrderItemFieldLabel" aria-hidden="true">
                              <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <span class="modal-title" id="updateWorkOrderItemFieldLabel"> Update Work Order Item Fields</span>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body">
                                    <form autocomplete="off"
                                          class="form-horizontal basic-form-container form-custom-select"
                                          id="UpdateFieldsForm">

                                      <div class="col form-group">
                                        <label class="control-label" for="period">Complaint:</label>
                                        <textarea type="text" class="form-control" v-model="complaint" id="complaint"
                                                  placeholder="Enter Complaint"
                                                  name="complaint"></textarea>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label" for="period">Cause:</label>
                                        <textarea type="text" class="form-control" v-model="cause" id="cause"
                                                  placeholder="Enter Cause"
                                                  name="cause"></textarea>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label" for="period">Correction:</label>
                                        <textarea type="text" class="form-control" v-model="correction"
                                                  id="correction"
                                                  placeholder="Enter Correction"
                                                  name="correction"></textarea>
                                      </div>
                                    </form>
                                  </div>
                                  <div class="btn-groups modal-footer">
                                    <button type="submit" id="updateFieldsBtn" class="btn btn-primary"
                                            v-on:click.prevent="updateWoiFields(complaint,cause,correction,currentWoiId)">
                                      <i class="fp-reload"> </i> Update
                                    </button>
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal"><i
                                        class="fp-close"> </i> Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <!--Line Item section-->
                      </template>
                    </section>
                </div>
                <!-- Sales Tax Exemption Message on basis of Customer Credit Information -->
                <section class="internal-container border-top-table-fl"
                         v-if="canViewGL && taskArr.length > 0 && tax_exempt != ''">
                  <h6 class="color-red">NOTE : {{ tax_exempt }}</h6>
                </section>
                <div v-show="detail_tab === 2" class="tabcontent">
                  <section class="internal-container border-top-table-fl mt-4" v-if="canViewGL && glArr.length > 0">
                    <template v-for="(glType , glTypeKey) in glArr">
                      <template v-if="glType.type != undefined && glType.type != null">
                        <template v-if="glType.detail != undefined && glType.detail.length > 0">
                          <div class="journal-title" :key="glType.type + glTypeKey">
                            <h5> {{ glType.type }}
                              <template v-if="glType.err_description">
                                <span :style="{ color: 'red' }"> ({{ glType.err_description }}) </span>
                              </template>
                              <i class="fp-down-arrow cursor-pointer"
                                 data-toggle="collapse"
                                 :data-target="'#detail'+glTypeKey"></i>
                            </h5>
                          </div>
                          <div :id="'detail'+glTypeKey" class="accordian-body collapse show"
                               :key="'detail'+glTypeKey">
                            <div class="table-reponsive-sm">
                              <table aria-describedby="table" id="gl_table" class="table table-bordered">
                                <thead>
                                <tr class="table-primary">
                                  <th>Trans Number</th>
                                  <th>Account</th>
                                  <th class="text-right">Debit</th>
                                  <th class="text-right">Credit</th>
                                  <th class="text-right">Amount</th>
                                </tr>
                                </thead>
                                <tbody v-if="glType.detail != undefined && glType.detail.length > 0">
                                <template v-for="(glItem , glKey) in glType.detail">
                                  <tr :key="'gl'+glKey">
                                    <td>{{ glItem.trans_number }}</td>
                                    <template v-if="glItem.account_description == 'Total'">
                                      <td class="text-right">{{ glItem.account_description }}</td>
                                    </template>
                                    <template v-else>
                                      <td>{{ glItem.account_description }}</td>
                                    </template>
                                    <td class="text-right">{{ glItem.debit }}</td>
                                    <td class="text-right">{{ glItem.credit }}</td>
                                    <td class="text-right">{{ glItem.journal_amount }}</td>
                                  </tr>
                                </template>
                                </tbody>
                                <tbody v-else>
                                <tr>
                                  <td colspan="4"><h5>No Data Found</h5></td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </template>
                      </template>
                    </template>
                  </section>
                </div>
                <!-- Special PO Items Modal -->
                <div class="modal fade select-date" :id="'select-date'" :ref="'select-date'"
                     data-backdrop="static" data-keyboard="false" aria-labelledby="selectDate"
                     aria-hidden="true">
                  <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">Are you sure that you want to Close WO Items?</h5>
                      </div>
                      <div class="modal-body">
                        <div class="form-row">
                          <div class="col-sm-6 form-group">
                            <label class="control-label" for="specialUnitDetail">WO Close
                              Date:</label>
                            <date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="open_date"
                                         name="open_date" v-model="date" :config="optionsDate"
                                         aria-describedby="basic-addon3" class='cal-icon'
                                         :disabled="disableWOFields"></date-picker>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button class="btn btn-primary" :id="'btnPOModalAdd'"
                                v-on:click="closeWOItem(); getSectionForReading(vehicle_id,vehicle_type_id,vUnitNo)">
                          Yes </button>
                        <button type="button" class="btn btn-tertiary" id="cancelRecallAssetBtn"
                                data-dismiss="modal"> No </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="detail_tab === 3" class="tabcontent">
                  <template v-if="show_adjust_tab">
                    <template v-if="adjustment_data_success">
                      <section class="internal-container border-top-table-fl mt-4">
                        <div class="table-reponsive-sm">
                          <section class="internal-container filters-container mb-4">
                            <div class="form-row">
                              <div class="col-md-6">
                                <div class="form-row form-group">
                                  <label class="col">Work Order:</label>
                                  <span class="col label"> {{ workOrderNoInfo }} </span>
                                </div>
                                <div class="form-row form-group">
                                  <label class="col"> SIP Balance:</label>
                                  <span class="col label">{{ sip_amount }} </span>
                                </div>
                                <div class="form-row form-group">
                                  <label class="col"> WO Adjust:</label>
                                  <span class="col label"> {{ wo_adjust }} </span>
                                </div>
                              </div>

                              <template v-if="found_uuu && found_uuu.length == 0">
                                <template v-if="show_adjust_sip_btn">
                                  <div class="col-md-6">
                                    <div class="form-row form-group d-flex justify-content-end">
                                      <button type="submit" class="btn btn-primary pull-right"
                                              v-on:click.prevent="openModal()"><i class="fp-add"> </i> Adjust SIP
                                      </button>
                                    </div>
                                  </div>
                                </template>
                              </template>
                              <template v-else>
                                <div class="col-md-6">
                                  <div class="form-row form-group d-flex justify-content-end">
                                    <span :style="{ color: 'red' }"> {{ found_uuu }} </span>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </section>
                          <table aria-describedby="table" id="adjustment_table" class="table table-bordered">
                            <thead>
                            <tr class="table-primary">
                              <th class="text-right">GL Code</th>
                              <th class="text-right">Gl Account</th>
                              <th class="text-right">Amount</th>
                              <th class="text-right">Source Document</th>
                              <th class="text-right">Work Order Transaction Type</th>
                              <th class="text-right">Accounting Transaction Type</th>
                              <th class="text-right">Accounting Transaction</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-if="is_account_payable">
                              <!-- <tr v-for="(res_account_payable, index) in account_payable" :key="index"> -->
                              <tr>
                                <td>{{ account_payable.gl_code }}</td>
                                <td>{{ account_payable.gl_account }}</td>
                                <td align="right">{{ account_payable.amount }}</td>
                                <td>{{ account_payable.source_document }}</td>
                                <td>{{ account_payable.wo_trans_type }}</td>
                                <td>{{ account_payable.acc_trans_type }}</td>
                                <td>{{ account_payable.acc_trans }}</td>
                              </tr>
                            </template>
                            <template v-if="is_general_ledger">
                              <!-- <tr v-for="(res_general_ledger, index1) in general_ledger" :key="index1"> -->
                              <tr>
                                <td>{{ general_ledger.gl_code }}</td>
                                <td>{{ general_ledger.gl_account }}</td>
                                <td align="right">{{ general_ledger.amount }}</td>
                                <td>{{ general_ledger.source_document }}</td>
                                <td>{{ general_ledger.wo_trans_type }}</td>
                                <td>{{ general_ledger.acc_trans_type }}</td>
                                <td>{{ general_ledger.acc_trans }}</td>
                              </tr>
                            </template>
                            <template v-if="is_sublet_adjustment">
                              <tr>
                                <td>{{ general_ledger.gl_code }}</td>
                                <td>{{ general_ledger.gl_account }}</td>
                                <td align="right">{{ general_ledger.amount }}</td>
                                <td>{{ general_ledger.source_document }}</td>
                                <td>{{ general_ledger.wo_trans_type }}</td>
                                <td>{{ general_ledger.acc_trans_type }}</td>
                                <td>{{ general_ledger.acc_trans }}</td>
                              </tr>
                            </template>
                            </tbody>
                          </table>
                        </div>
                      </section>
                    </template>
                  </template>
                </div>
              </template>
              <template v-else>
                <!-- Work Order Crm -->
                <div id="work-order-crm-list" class="admin-page-content work-order-view list-view">
                  <template v-if="crmAdd">
                    <crm-create :fromModule="workOrderObj"></crm-create>
                  </template>
                  <template v-else>
                    <button v-if="canAddCrm" type="submit" class="btn btn-primary pull-right"
                            v-on:click.prevent="addCrm"><i class="fp-add"> </i>Add</button>
                    <section class="internal-container border-top-table-fl"
                             style="margin-top:40px !important;">
                      <div class="bg-white data-table p-0">
                        <work-order-crm-list v-if="enableWOCrm" :moduleVal="'work order'"
                                             :moduleId="work_order_id"></work-order-crm-list>
                      </div>
                    </section>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </template>

        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>Oops!</h1>
                    <h2>403</h2>
                    <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
      <div class="modal fade make-bill-date-modal" id="sipAdjustModel" ref="sipAdjustModel" data-backdrop="static"
           data-keyboard="false" aria-labelledby="makePaymentModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">SIP Adjust</h5>
              <button type="button" class="close" id="btnModalClose" v-on:click="hideModal()">&times;</button>
            </div>
            <div class="modal-body">
              <section class="internal-container border-top-table-fl filters-container mb-4">
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-row form-group">
                      <label class="col">Work Order:</label>
                      <span class="col label" id="workOrderNoInfo"> {{ workOrderNoInfo }} </span>
                    </div>
                    <div class="form-row form-group">
                      <label class=" require"> Po Number :</label>
                      <template v-if="poArr.length > 0">
                        <span class="col label" id="po_number"> {{ poArr[0].name}} </span>
                      </template>
<!--                      <div class="col">-->
<!--                        <v-select v-model="po_number" name="po_number" id="po_number" :disabled=modelDisabled-->
<!--                                  label="text" :filterable="false" :options="poArr"-->
<!--                                  placeholder="Select PO"-->
<!--                        >-->
<!--                          <template slot="no-options">-->
<!--                            Search PO...-->
<!--                          </template>-->
<!--                          <template slot="option" slot-scope="option">-->
<!--                            <div class="d-center">-->
<!--                              {{ option.name }}-->
<!--                            </div>-->
<!--                          </template>-->
<!--                          <template slot="selected-option" slot-scope="option">-->
<!--                            <div class="selected d-center">-->
<!--                              {{ option.name }}-->
<!--                            </div>-->
<!--                          </template>-->
<!--                        </v-select>-->
<!--                      </div>-->
                    </div>
                    <div class="form-row form-group">
                      <label class="control-label require"> Transaction Date:</label>
                      <div class="input-group">
                        <date-picker placeholder="DD/MM/YYYY" id="transaction_date" name="transaction_date" :disabled=modelDisabled
                                     v-model="transaction_date"
                                     @input="onChangeTransactionDate"
                                     aria-describedby="basic-addon3"></date-picker>
                        <label for="fiscal_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                      </div>
                    </div>
                    <div class="form-row form-group" hidden>
                      <label class="control-label require">Fiscal Period</label>
                      <div class="input-group">
                        <date-picker placeholder="MM/YYYY" id="fiscal_date" name="fiscal_date" v-model="fiscal_date"
                                     :config="optionsFiscalDate" aria-describedby="basic-addon3"
                                     disabled=""></date-picker>
                      </div>
                      <div class="field-error">{{ fiscal_date_error_msg }}</div>
                    </div>
                  </div>
                </div>
              </section>
              <div class="form-row row-cols-md-12 row-cols-1">
                <div class="purchase-order-create-main table-responsive-sm">
                  <table aria-describedby="table" class="table table-sm table-bordered font-1">
                    <thead>
                    <tr class="table-primary">
                      <th scope="col" class="require" style="width:300px">GL Account</th>
                      <th scope="col">Description</th>
                      <th scope="col" class="require">Debit</th>
                      <th scope="col" class="require">Credit</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in rows" :key="index">
                      <td>
                        <v-select v-model="row.account" name="account" id="account" :disabled=modelDisabled
                                  label="text" :filterable="false" :options="accountsArr"
                                  @search="onSearchAccount"
                                  placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                          <template slot="no-options">
                            Search Account...
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              {{ option.text }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ option.text }}
                            </div>
                          </template>
                        </v-select>
                        <div class="field-error">{{ row.account_error_msg }}</div>
                      </td>
                      <td>
                        <input type="text" placeholder="Description" v-model="row.description" id="description"
                               class="form-control" disabled>
                        <div class="field-error">{{ row.description_error_msg }}</div>
                      </td>
                      <td>
                        <template v-if="row.debitDisabled === 0">
                          <input type="text" placeholder="0.00" v-model="row.debit" id="debit"
                                 class="form-control text-right" @keypress="isNumberOnly($event)" disabled>
                        </template>
                        <template v-else>
                          <input type="text" placeholder="0.00" v-model="row.debit"
                                 class="form-control text-right" disabled>
                        </template>
                        <div class="field-error">{{ row.debit_error_msg }}</div>
                      </td>
                      <td>
                        <template v-if="row.creditDisabled === 0">
                          <input type="text" placeholder="0.00" v-model="row.credit" id="credit"
                                 class="form-control text-right" @keypress="isNumberOnly($event)" disabled>
                        </template>
                        <template v-else>
                          <input type="text" placeholder="0.00" v-model="row.credit"
                                 class="form-control text-right" disabled>
                        </template>
                        <div class="field-error">{{ row.credit_error_msg }}</div>
                      </td>
                    </tr>
                    <div class="field-error">{{ total_dr_cr_error }}</div>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary btnBillRevJeHeaderAdd" id="btnBillRevJeHeaderAdd"
                      v-on:click="createGlForSip()" :disabled=modelDisabled> Submit
              </button>
              <button class="btn btn-tertiary" id="btnBillRevJeHeaderModalCancel" v-on:click="hideModal()" :disabled=modelDisabled> Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade select-date" :id="'select-date'" :ref="'select-date'" data-backdrop="static" data-keyboard="false" aria-labelledby="selectDate" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Are you sure that you want to Close WO Items?</h5>
          </div>
          <div class="modal-body">
            <div class="form-row" >
              <div class="col-sm-6 form-group">
                <label class="control-label"  for="specialUnitDetail">WO Close Date:</label>
                <date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="open_date" name="open_date" v-model="date" :config="optionsDate" aria-describedby="basic-addon3" class='cal-icon' :disabled="disableWOFields"></date-picker>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" :id="'btnPOModalAdd'" v-on:click="closeWOItem(); getSectionForReading(vehicle_id,vehicle_type_id,vUnitNo)"> Yes </button>
            <button type="button" class="btn btn-tertiary" id="cancelRecallAssetBtn" data-dismiss="modal"> No </button>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import Vue from "vue";
import {
    commonMixins
} from "../mixins/commonMixins";

import ActivityLogListView from '@/components/ActivityLogList.vue';
import VendorInvoiceForm from '@/components/accounting/VendorInvoiceForm.vue';
import CrmCreate from "@/components/CrmCreate.vue";
import moment from 'moment';
Vue.component("crm-create", CrmCreate);


Vue.component("workorder-activity-log-list", ActivityLogListView);
Vue.component("vendor-invoice-form", VendorInvoiceForm);
export default {
    name: "WorkOrderView",
    components: {
        
        workOrderCrmList: () => import('@/components/CrmList.vue')
    },
    mixins: [commonMixins],
    data: () => ({
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        loading: false,
        canListWorkOrder: false,
        workOrderNoInfo: '',
        unitNumber: '',
        assetInfo: '',
        customerInfo: '',
        openDateInfo: '',
        closeDateInfo: '',
        approvedInfo:'',
        requestCompInfo: '',
        agreedDateInfo: '',
        userInfo: '',
        woStatusInfo: '',
        alias_number: '',
        milesInfo: '',
        locationInfo: '',
        priorityInfo: '',
        woNotesInfo: '',
        maintenanceTypeInfo: '',
        scheduleMaintenanceInfo: '',
        isMiscellaneousInfo:'',
        customerEmailInfo:'',
        customerUnitNoInfo:'',
        customerVinNumberInfo:'',
        showMiscellaneousFields:false,
        laborAmount: 0,
        componentAmount: 0,
        subTotal: 0,
        discount: 0,
        discountAmount: 0,
        tax: 0,
        taxAmount: 0,
        total: 0,
        taskArr: [],
        laborArr: [],
        componentArr: [],
        commentArr: [],
        laborHourArr: [],
        activityArr: [],
        serviceTaskArr: [],
        itemSelection: 0,
        selecttaskArr: [],
        contractData:[],
        displayFix: false,
        activetab: 1,
        activityLogsTabValue: "woloadList",
        activityLoaded:false,
        subletAmount:0,
        cust_estimate_wo_id:'',
        custEstGenerated:'',
        venEstGenerated:'',
        poGenerated:'',
        pageKey:"",
        invoiceGenerated:'false',
        showBillBtn:false,
        custPoNo:'',
        custPoId:0,
        canViewWoSummary:false,
        createPoFromWO:false,
        poDataFromWO:{
            woId:0,
            woItemId:0,
            redirectFrom:""
        },
        createSubletPO:"subletPO",
        createInvoiceFromWOPO:false,
        poDataFromWOForInvoice:{
            poId:0,
            woItemId:0,
            billId:0,
            type:""
        },
        createSubletInvoicePO:"subletInvoice",
        canVerifyVendorInvoice:false,
        canAddVendorInvoice:false,
        canUpdateVendorInvoice:false,
        canUpdateVendorPO:false,
        create_warranty_claim:false,
        canApproveWO:false,
        vehicle_id:0,
        setFlagClaim:'add',
        glArr:[],
        canViewGL:false,
        userRole:"",
        tax_exempt:"",
        warranty:'',
        work_order_id:"",
        enableWOCrm:false,
        workOrderObj:{},
        isCrmSection:false,
        canAddCrm:false,
        crmAdd:false,
        crmBtnTitle:"CRM",
        fromUrl:'',
        from:'',
        sectionArr:[],
        createHeaderInvoice:false,
        woType:'',
        vUnitNo: '',
        assetRequired:true,
        woItemsClose:false,
        poStatus:'',
        lineSequence:0,
        serial_number:'',
        invoice_id:"",
        otherCharges:0,
        shopSupplies:0,
        addMiles:false,
        OutOfService:'',
        showSaveButton: false,
        closedate:'',
        date:'',
        disableWOFields:false,
        optionsDate: {
        format: 'MM/DD/YYYY hh:mm:ss a',
        useCurrent: false,
        toolbarPlacement:'bottom',
        widgetPositioning: {
            horizontal: 'auto',
            vertical: 'bottom'
        },
        showClose: true,
        },
        assetPoolInfo: "",
        cause: "",
        complaint: "",
        correction: "",
        currentWoiId: "",
        requestInProgress:false,
        continueCloseItem: true,
        existingReading: [],
        detail_tab: 3,
        account_payable: [],
        general_ledger: [],
        sublet_adjustment: [],
        sip_amount: 0,
        found_uuu: '',
        wo_adjust: 0,
        line_details: '',
        gl_details: '',
        adjustment: '',
        selectedStatus: '',
        transaction_date: '',
        po_number: '',
        gl_account: '',
        gl_amount: '',
        gl_account_err: '',
        gl_amount_err: '',
        fiscal_date:'',
        fiscal_date_error_msg:'',
        post_date: '',
        header_desc:"W# "+self.work_order_id+" SIP Correct",
        optionsFiscalDate:{
          format: 'MM/YYYY',
          useCurrent: true,
        },
        rows: [],
        gl_account_id:'',
        gl_account_name: '',
        adjustment_data_success: false,
        is_account_payable: false,
        is_general_ledger: false,
        is_sublet_adjustment: false,
        show_adjust_sip_btn: true,
        show_adjust_tab: false,
        gl_data_success: false,
        accountsArr:[],

        account: '',
        account_error_msg: '',
        description: '',
        description_error_msg: '',
        debit: '',
        debit_error_msg: '',
        credit: '',
        credit_error_msg: '',
        poArr: [],
        total_dr_cr_error: '',
        modelDisabled:false,
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == "view_work_order") {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == "list_work_order") {
                        self.canListWorkOrder = true;
                    }
                    //used
                    if (permissions[i].name == 'can_view_work_order_summary') {
                        self.canViewWoSummary = true;
                    }
                    if (permissions[i].name == 'can_verify_vendor_invoice') {
                        self.canVerifyVendorInvoice = true;
                    }
                    if (permissions[i].name == 'add_vendor_invoice') {
                        self.canAddVendorInvoice = true;
                        self.canUpdateVendorInvoice = true;
                    }
                    if (permissions[i].name == 'add_purchase_order') {
                        self.canUpdateVendorPO = true;
                    }
                    if (permissions[i].name == 'view_general_ledger') {
                        self.canViewGL = true;
                    }
                    if (permissions[i].name == 'add_crm') {
                        self.canAddCrm = true;
                    }
                    if ( permissions[i].name == "can_approve_work_order" ) {
                        self.canApproveWO = true;
                    }
                }
            }
        },
        laborArr: {
            handler: function (newValue) {
                var self = this;

                for (var i = 0; i < self.serviceTaskArr.length; i++) {

                    var labor = false;
                    var serviceTaskIdx = self.serviceTaskArr[i].index;

                    for (var j = 0; j < newValue.length; j++) {

                        if (newValue[j].service_task_id != null) {

                            var taskIdx = newValue[j].service_task_id.index;

                            if (taskIdx == serviceTaskIdx) {

                                labor = true;

                            }

                        }
                    }

                    self.taskArr[serviceTaskIdx].hasLabor = labor;

                }
            },
            deep: true
        },
        componentArr: {
            handler: function (newValue) {
                var self = this;

                for (var i = 0; i < self.serviceTaskArr.length; i++) {

                    var component = false;
                    var serviceTaskIdx = self.serviceTaskArr[i].index;

                    for (var j = 0; j < newValue.length; j++) {

                        if (newValue[j].service_task_id != null) {

                            var taskIdx = newValue[j].service_task_id.index;

                            if (taskIdx == serviceTaskIdx) {

                                component = true;

                            }

                        }
                    }

                    self.taskArr[serviceTaskIdx].hasComponent = component;

                }
            },
            deep: true
        },
        commentArr: {
            handler: function (newValue) {
                var self = this;

                for (var i = 0; i < self.serviceTaskArr.length; i++) {

                    var comment = false;
                    var serviceTaskIdx = self.serviceTaskArr[i].index;

                    for (var j = 0; j < newValue.length; j++) {

                        if (newValue[j].service_task_id != null) {

                            var taskIdx = newValue[j].service_task_id.index;

                            if (taskIdx == serviceTaskIdx) {

                                comment = true;

                            }

                        }
                    }

                    self.taskArr[serviceTaskIdx].hasComment = comment;

                }
            },
            deep: true
        },
      rows: {
        handler: function (val, oldVal) {
          var self = this;
          var debitTotal = 0;
          var creditTotal = 0

          for (var j = 0; j < val.length; j++) {
            debitTotal += Number(val[j].debit);
            creditTotal += Number(val[j].credit);
            // console.log("debit == ", val[j]);
            // if (val[j].debitDisabled == 0) {
            //   if (val[j].debit != "" && val[j].debit != "." && val[j].debit != "-") {
            //     debitTotal += Number(val[j].debit.replace(/\,/g,""));
            //     console.log("debitTotal == ", debitTotal);
            //   }
            // }
            // console.log("credit  == ", val[j].credit);
            // if (val[j].creditDisabled == 0) {
            //   if (val[j].credit != "" && val[j].credit != "." && val[j].credit != "-") {
            //     creditTotal += Number(val[j].credit.replace(/\,/g,""));
            //     console.log("creditTotal == ", creditTotal);
            //   }
            // }
          }

          self.debitSubTotal = debitTotal.toFixed(2);
          self.creditSubTotal = creditTotal.toFixed(2);

          var debitTotalUpdate = debitTotal - Number(self.creditSubTotal);
          var creditTotalUpdate = creditTotal - Number(self.debitSubTotal);

          if (debitTotalUpdate == 0 || (Number(self.debitTotal) > Number(creditTotal)) || (Number(self.debitSubTotal) > Number(self.creditSubTotal)) ) {
            self.debitTotal = self.debitSubTotal;
          }else{
            self.debitTotal = debitTotalUpdate.toFixed(2);
          }

          if (creditTotalUpdate == 0 || (Number(self.creditTotal) > Number(debitTotal)) || (Number(self.creditSubTotal) > Number(self.debitSubTotal)) ) {
            self.creditTotal = self.creditSubTotal;
          }else{
            self.creditTotal = creditTotalUpdate.toFixed(2);
          }

          self.displayDebit = self.amountFormat(self.debitSubTotal);
          self.displayCredit = self.amountFormat(self.creditSubTotal);
          if(self.displayCredit == "" && self.displayDebit == "") {
            self.difference = self.amountFormat("0");
          } else {
            self.difference = self.amountFormat(self.removeFormat(self.displayCredit) - self.removeFormat(self.displayDebit));
          }

        },
        deep: true
      }
    },
    beforeMount() {
        var self = this;
        // self.activityLogsTabValue= "dontLoadList";
    },
    created: function () {
    },
    beforeRouteLeave(to, from, next) {
        var self = this;
        self.left_view_edit_channel(from.fullPath);
        next();
    },
    mounted: function () {
        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");
        self.pageKey='_workorder_view_'+segments[3];
        self.work_order_id = segments[3];

        self.date = moment().format('MM/DD/YYYY hh:mm:ss a');
        if(self.$route.query.fromUrl != "" && self.$route.query.fromUrl != undefined){
          self.fromUrl = atob(self.$route.query.fromUrl);
        }
        self.getPermissions();
        self.loadWorkOrderDetail();
        self.getAllPoList();
        self.hideModal();

        //set value in work order object for crm
        self.workOrderObj.module = "work order";
        self.workOrderObj.work_order_id = segments[3];
        self.workOrderObj.flag = "add";
        self.workOrderObj.crm_id = "";

        //check user loggged in or not
        var userObj = localStorage.getItem("user_obj");

        //if user logged in than remove login button and registration button
        if (userObj != null) {
            var userJson = JSON.parse(userObj);
            if (userJson.roles.length > 0) {
                this.userRole = userJson.roles[0].name;

            }
        }

        $(window).scroll(function () {

            var scrollDistance = $(window).scrollTop();
            //alert($(window).scrollTop());
            $('.PageTop').each(function (i) {

                if (scrollDistance > 190) {
                    $(".PageTop").addClass("PageTopFix");
                    self.displayFix = true;
                } else {
                    $(".PageTop").removeClass("PageTopFix");
                    self.displayFix = false;
                }
            });
        });

        if (self.$route.query.from != undefined) {
            if (self.$route.query.from != null && self.$route.query.from != "" && self.$route.query.from != 0) {
                //open line item on basis of id
                setTimeout(function () {
                    if ($("#item"+self.$route.query.from).length > 0) {
                        $("#item"+self.$route.query.from).click();
                    }else{
                        $(".accordion-toggle:first").click();
                    }
                }, 3000);
            }else{
                //open first accordian when load page
                setTimeout(function () {
                    $(".accordion-toggle:first").click();
                }, 3000);
            }
        }else{
            //open first accordian when load page
            setTimeout(function () {
                $(".accordion-toggle:first").click();
            }, 3000);
        }

        setTimeout(function () {
            $('.right-asset-tab-list').on('click', 'li', function () {
                $('.right-asset-tab-list li.active').removeClass('active');
                $(this).addClass('active');
            });

            //prevent closing line item when click on checkbox
            $(".line-item-internal-section .custome-checkbox").click(function(e){
                e.stopPropagation();
            });

            $(".line-item-internal-section .custome-checkbox").click(function(e){
              e.stopPropagation();
            });

            $('#workOrder-table .accordian-body').on('show.bs.collapse', function () {
              $(this).closest("table")
                  .find(".collapse.in")
                  .not(this)
                  .collapse('toggle')
            });

            $(function () {
              $('[data-toggle="popover"]').popover()
            });

        }, 3000);

        //Join ViewEdit Channel
        self.join_view_edit_channel(segments[1],segments[2],segments[3]);


      const prevSelectedTab = localStorage.getItem("wo_view_tab");
      if (prevSelectedTab == null || prevSelectedTab === 'line_details') {
        self.detail_tab = 1;
        self.selectedStatus = "line_details";
        self.line_details = 'active';
        localStorage.setItem('wo_view_tab', 'line_details');

      } else if (prevSelectedTab === 'gl_details') {
        self.detail_tab = 2;
        self.selectedStatus = "gl_details";
        self.gl_details = 'active';
        localStorage.setItem('wo_view_tab', 'gl_details');

      } else if (prevSelectedTab === 'adjustment') {
        self.getSipApglData();
        self.detail_tab = 3;
        self.selectedStatus = "adjustment";
        self.adjustment = 'active';
        localStorage.setItem('wo_view_tab', 'adjustment');
      }

      self.rows.push({
        journal_item_id:0,
        account:"",
        account_error_msg:"",
        debit: self.sip_amount,
        debit_error_msg:"",
        credit:"",
        credit_error_msg:"",
        description:"W# "+self.work_order_id+" SIP Correct",
        description_error_msg:"",
        debitDisabled:0,
        creditDisabled:0,
        vehicle_id:'',
        vehicle_error_msg:'',
        is_cap_cost:false
      },{
        journal_item_id:0,
        account:"",
        account_error_msg:"",
        debit:"",
        debit_error_msg:"",
        credit: self.sip_amount,
        credit_error_msg:"",
        description:"W# "+self.work_order_id+"SIP Correct",
        description_error_msg:"",
        debitDisabled:0,
        creditDisabled:0,
        is_cap_cost:false,
        sip_adjust_not_found:false
      });

      const todayDate = self.getTodayDate();
      const postDate = moment(todayDate,"MM/DD/YYYY");
      self.post_date = postDate._i;
    },
    metaInfo() {
        return {
            title: (this.workOrderNoInfo != "") ? this.workOrderNoInfo + " | Work Order View | " +process.env.COPYRIGHT_NAME:"Work Order View | " +process.env.COPYRIGHT_NAME
        }
    },
    methods: {

        //change approve wo status back to close
        disapproveWo() {

            var self = this;
            self.loading = true;

            self.$swal({
                title: 'Are you sure that you want to disapprove this Work Order?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {

                if (result.value) {

                    $.ajax({
                        url: process.env.ROOT_API + '/workorder/disapprove',
                        type: "POST",
                        data: { wo_id:self.work_order_id },
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;

                            if ( data.code == 200 ) {

                                //reload workorder details
                                //self.loadWorkOrderDetail();

                            } else {
                                self.$swal('',data.message,'warn');
                            }

                            //reload workorder details
                            self.loadWorkOrderDetail();

                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, true, 'generate-purchase-order');
                        }
                    });

                }
            })
        },
        editWorkOrder() {

            var self = this;
            self.$router.push("/workorder/edit/" + self.work_order_id+"?fromUrl="+btoa(window.location.pathname+window.location.search));
        },
        loadWorkOrderDetail() {

            var self = this;
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/workorder/" + self.work_order_id,
                type: "GET",
                headers: this.ajxHeaders,
                data:{
                    action_flag : 'view', // pass action for notify: view, edit
                    is_notify_flag : true // notify if user viewing or editing
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        var storeObject={visited_page: {
                                    path : "WorkOrder |" +data.content.work_order_no,
                                    data : window.location.pathname,
                                    }};
                        self.getRecentlyPagesMethod(storeObject);
                        self.workOrderObj.customer_id = data.content.customer_id;
                        self.workOrderNoInfo = data.content.work_order_no;
                        self.workOrderObj.lockStatus = data.content.lock_status;
                        self.custPoNo = data.content.customer_po_no;
                        self.woType = data.content.wo_type;
                        if (data.content.wo_type == 'multi unit'){
                            self.assetRequired = false;
                        }else{
                            self.assetRequired = true;
                        }

                      for (var i = 0; i < data.content.sectionData.length; i++) {
                        if (data.content.sectionData[i].read_on_wo == 'mandatory') {
                          self.showSaveButton = true
                          break;
                        }
                      }
                        console.log('show button', self.showSaveButton)

                        // if ( data.content.customer_purchase_order_id ) {
                        //     self.custPoId = data.content.customer_purchase_order_id;
                        // }

                        if (data.content.vehicle_id == null){
                            if (data.content.customer_unit_no && data.content.customer_unit_no != ''){

                                self.assetInfo = data.content.customer_unit_no+' | '+data.content.customer_vin_number;

                            }else{

                                self.assetInfo = data.content.customer_vin_number;

                            }
                        }else{
                            self.vehicle_id = data.content.vehicle_id;
                            self.vehicle_type_id = data.content.vehicle_type_id;
                            self.vUnitNo = data.content.vUnitNo;
                            self.assetInfo = data.content.vUnitNo + " | " + data.content.vtCode + " | " + data.content.vName;
                            self.unitNumber = data.content.vUnitNo;
                            self.workOrderObj.vehicle_id = data.content.vehicle_id;
                        }
                        if (data.content.vehicle_pool_id != null){
                          self.assetPoolInfo = data.content.vehicle_pool_code + " | " + data.content.vehicle_pool_description;
                        }
                        if (data.content.cusCode != null){
                            self.customerInfo = data.content.cusCode + " | " + data.content.cusName;
                        }
                        if (data.content.open_date != null) {
                            self.openDateInfo = data.content.open_date;
                        } else {
                            self.openDateInfo = "-";
                        }
                        if (data.content.close_date != null) {
                            self.closeDateInfo = data.content.close_date;
                        } else {
                            self.closeDateInfo = "-";
                        }
                        if (data.content.requested_completion != null) {
                            self.requestCompInfo = data.content.requested_completion;
                        } else {
                            self.requestCompInfo = "-";
                        }
                        if (data.content.agreed_date != null) {
                            self.agreedDateInfo = data.content.agreed_date;
                        } else {
                            self.agreedDateInfo = "-";
                        }
                        self.locationInfo = data.content.lCode + " | " + data.content.lName;

                        self.approvedInfo = data.content.approved_by;
                        self.workOrderObj.approvedAt = data.content.approval_date;

                        self.userInfo = self.titleCase(data.content.uFirstName + " " + data.content.uLastName);
                        self.woStatusInfo = self.titleCase(data.content.status);
                        self.alias_number = data.content.alias_number;
                        if (data.content.serial_number != undefined && data.content.serial_number != null && data.content.serial_number != "") {
                            self.serial_number = data.content.serial_number;
                        }
                        if (data.content.description != null && data.content.description != "") {
                            self.woNotesInfo = data.content.description;
                        } else {
                            self.woNotesInfo = "-";
                        }

                        self.milesInfo = data.content.miles;
                        if (data.content.priority != null) {
                            self.priorityInfo = data.content.priorityName + " (" + data.content.priority + ")";
                        } else {
                            self.priorityInfo = "-";
                        }
                        self.maintenanceTypeInfo = self.titleCase(data.content.maintenanceTypeName);
                        if (data.content.schedule_maintenance_id != null) {
                            if (data.content.schedule_date != null) {
                                self.scheduleMaintenanceInfo = data.content.vUnitNo + " (" + data.content.schedule_date + ")";
                            } else {
                                self.scheduleMaintenanceInfo = data.content.vUnitNo + " ()";
                            }
                        } else {
                            self.scheduleMaintenanceInfo = "-";
                        }
                        self.laborAmount = data.content.labor_amount;
                        self.componentAmount = data.content.component_amount;
                        self.subTotal = data.content.sub_amount;
                        self.discount = data.content.discount;
                        self.discountAmount = data.content.discount_amount;
                        self.tax = data.content.tax;
                        // self.taxAmount = data.content.tax_amount;
                        self.taxAmount = data.content.total_tax;
                        self.total = data.content.total_amount;
                        self.otherCharges = data.content.other_charges;
                        self.shopSupplies = data.content.shop_supplies;
                        if(data.content.is_miscellaneous == 1){
                            self.isMiscellaneousInfo = "Yes";
                            self.showMiscellaneousFields = true;
                            self.customerEmailInfo = data.content.customer_email;
                            self.customerVinNumberInfo = data.content.customer_vin_number;
                            self.customerUnitNoInfo = data.content.customer_unit_no;
                        }else{
                            self.isMiscellaneousInfo = "No";
                            self.showMiscellaneousFields = false;
                        }
                        if ( data.content.estimate_work_order_id != null){

                            self.cust_estimate_wo_id = data.content.estimate_work_order_id;

                        }

                        if (data.content.cust_est_generated){

                            self.custEstGenerated = data.content.cust_est_generated;

                        }
                        if (data.content.ven_est_generated){

                            self.venEstGenerated = data.content.ven_est_generated;

                        }
                        if (data.content.po_generated){

                            self.poGenerated = data.content.po_generated;

                        }
                        self.contractData = data.content.contractData;
                        self.invoiceGenerated = data.content.invoice_generated;
                        self.invoice_id = data.content.invoice_id;
                        if (data.content.sectionData){
                            self.sectionArr = data.content.sectionData;
                            self.existingReading = self.sectionArr.map(item => item.reading);
                        }
                        self.OutOfService = data.content.out_of_service;
                        self.workOrderItemData();

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'get-workorder-detail-view');
                }
            });
        },
        workOrderItemData() {

            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/workorder/get-workorder-item",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    work_order_id: self.work_order_id,
                },
                success: function (data) {

                    if (data.code == 200) {

                        self.taskArr = [];
                        self.componentArr = [];
                        self.laborArr = [];
                        self.commentArr = [];
                        self.laborHourArr = [];
                        self.activityArr = [];
                        // self.selecttaskArr = [];

                        if (data.content.item != undefined) {
                            self.serviceTaskArr = []
                            if (data.content.item[0].po_status != undefined){
                                self.poStatus = data.content.item[0].po_status;
                            }

                            for (var i = 0; i < data.content.item.length; i++) {

                                if (data.content.item[i] && data.content.item[i].woistatus && data.content.item[i].woistatus == 'closed'){
                                    self.woItemsClose = true;
                                }else{
                                    self.woItemsClose = false;
                                }
                                if(data.content.item[i].billable_code=="B"){
                                    self.showBillBtn=true;
                                }
                                self.taskArr.push({

                                    // wo_id: (data.content[i].wo_id != undefined && data.content[i].wo_id != null && data.content[i].wo_id != '')?data.content[i].wo_id:0,
                                    woiId: (data.content.item[i].wo_item_id != undefined && data.content.item[i].wo_item_id != null && data.content.item[i].wo_item_id != '') ? data.content.item[i].wo_item_id : 0,
                                    taskid: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '') ? {
                                        value: data.content.item[i].task_id,
                                        text: self.titleCase(data.content.item[i].task_code + " | " + data.content.item[i].task_name)
                                    } : null,
                                    laboramount: data.content.item[i].labor_amount,
                                    partamount: data.content.item[i].component_amount,
                                    component_category_id: (data.content.item[i].component_category_id != undefined && data.content.item[i].component_category_id != null && data.content.item[i].component_category_id != '') ? {
                                        value: data.content.item[i].component_category_id,
                                        text: self.titleCase(data.content.item[i].component_category_code + " | " + data.content.item[i].component_category_name)
                                    } : null,
                                    wi_reason_id: (data.content.item[i].wi_reason_id != undefined && data.content.item[i].wi_reason_id != null && data.content.item[i].wi_reason_id != '') ? {
                                        value: data.content.item[i].wi_reason_id,
                                        text: self.titleCase(data.content.item[i].wi_reason_code + " | " + data.content.item[i].wi_reason_name)
                                    } : "-",
                                    billable_code: (data.content.item[i].billable_code != undefined && data.content.item[i].billable_code != null && data.content.item[i].billable_code != '') ? {
                                        value: data.content.item[i].billable_code,
                                        text: self.titleCase(data.content.item[i].billable_code + " | " + data.content.item[i].billable_code_name)
                                    } : null,
                                    defect_id: (data.content.item[i].standard_defect_id != undefined && data.content.item[i].standard_defect_id != null && data.content.item[i].standard_defect_id != '') ? {
                                        value: data.content.item[i].standard_defect_id,
                                        text: self.titleCase(data.content.item[i].standard_defect_code + " | " + data.content.item[i].standard_defect_name)
                                    } : "-",
                                    woistatus: {
                                        value: data.content.item[i].woistatus,
                                        text: self.titleCase(data.content.item[i].woistatus)
                                    },
                                    woicomplaint: data.content.item[i].complaint,
                                    woicause: data.content.item[i].cause,
                                    woicorrection: data.content.item[i].correction,
                                    woinotes: data.content.item[i].notes,

                                    est_repair_time: data.content.item[i].est_repair_time,
                                    std_repair_time: data.content.item[i].std_repair_time,

                                    issublet: data.content.item[i].issublet,
                                    sublet_amount: data.content.item[i].sublet_amount,
                                    purchaseorderid: (data.content.item[i].purchaseorderid != undefined && data.content.item[i].purchaseorderid != null && data.content.item[i].purchaseorderid != '') ? {
                                        value: data.content.item[i].purchaseorderid,
                                        text: self.titleCase(data.content.item[i].purchaseorderno) + " | " + data.content.item[i].purchaseordertotal
                                    } : "-",
                                    vendorid: (data.content.item[i].vendorid != undefined && data.content.item[i].vendorid != null && data.content.item[i].vendorid != '') ? {
                                        value: data.content.item[i].vendorid,
                                        text: self.titleCase(data.content.item[i].vendorcode + " | " + data.content.item[i].vendorname)
                                    } : "-",
                                    estimatedwoiId: (data.content.item[i].estimate_wo_item_id != undefined && data.content.item[i].estimate_wo_item_id != null && data.content.item[i].estimate_wo_item_id != '') ? data.content.item[i].estimate_wo_item_id : 0,
                                    estimatedlaboramount: data.content.item[i].estimate_wo_item_labor_amount,
                                    // itemSelection:0
                                    // subtotal: 0,
                                    // hasLabor: false,
                                    // hasComp: false
                                    vendor_est_id:	data.content.item[i].vendor_est_id,
                                    vendor_est_item_id:	data.content.item[i].vendor_est_item_id,
                                    vendor_estimate_no:	data.content.item[i].vendor_estimate_no,
                                    sent_status:data.content.item[i].sent_status,
                                    estimation_status:data.content.item[i].estimation_status,
                                    vendor_estimate_part_amount:data.content.item[i].vendor_estimate_part_amount,
                                    vendor_estimate_labor_amount:data.content.item[i].vendor_estimate_labor_amount,

                                    cust_est_id:data.content.item[i].cust_est_id,
                                    cust_est_item_id:data.content.item[i].cust_est_item_id,
                                    cust_estimate_no:data.content.item[i].cust_estimate_no,
                                    cust_sent_status:data.content.item[i].cust_sent_status,
                                    cust_estimate_part_amount:data.content.item[i].cust_estimate_part_amount,
                                    cust_estimate_labor_amount:data.content.item[i].cust_estimate_labor_amount,

                                    po_id:data.content.item[i].po_id,
                                    po_no:data.content.item[i].po_no,
                                    po_total:data.content.item[i].po_total,
                                    po_vendor:data.content.item[i].po_vendor,
                                    bill:data.content.item[i].bill,
                                    bill_id:data.content.item[i].bill_id,
                                    bill_amount:data.content.item[i].bill_amount,
                                    bill_status:data.content.item[i].bill_status,
                                    voucher:data.content.item[i].voucher,
                                    log_found:data.content.item[i].log_found,
                                    create_vendor_invoice:0,
                                    create_warranty_claim:0,
                                    po_data_from_wo:{
                                        poId:(data.content.item[i].po_id != undefined && data.content.item[i].po_id != null && data.content.item[i].po_id != "")?data.content.item[i].po_id:0,
                                        woItemId:(data.content.item[i].wo_item_id != undefined && data.content.item[i].wo_item_id != null && data.content.item[i].wo_item_id != '') ? data.content.item[i].wo_item_id : 0,
                                        billId:(data.content.item[i].bill_id != undefined && data.content.item[i].bill_id != null && data.content.item[i].bill_id != '') ?data.content.item[i].bill_id: 0,
                                        type:"sublet_invoice",
                                        vmrs_name:(data.content.item[i].component_category_id != undefined && data.content.item[i].component_category_id != null && data.content.item[i].component_category_id != '') ?
                                        self.titleCase(data.content.item[i].component_category_code + " | " + data.content.item[i].component_category_name): "",
                                        task_name:(data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '') ?
                                        self.titleCase(data.content.item[i].task_name):"",
                                        po_amount:(data.content.item[i].po_amount != undefined && data.content.item[i].po_amount != null && data.content.item[i].po_amount != "")?data.content.item[i].po_amount:0,
                                        wo_type:self.woType,
                                        vehicle_id:(self.woType == "default")?self.vehicle_id:data.content.item[i].vehicle_id
                                    },
                                    warranty_from_wo:{
                                        woItemId:(data.content.item[i].wo_item_id != undefined && data.content.item[i].wo_item_id != null && data.content.item[i].wo_item_id != '') ? data.content.item[i].wo_item_id : 0,
                                        vmrs_name:(data.content.item[i].component_category_id != undefined && data.content.item[i].component_category_id != null && data.content.item[i].component_category_id != '') ?
                                        self.titleCase(data.content.item[i].component_category_name): "",
                                        task_name:(data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '') ?
                                        self.titleCase(data.content.item[i].task_name):"",
                                        vehicle_id:self.vehicle_id,
                                        wo_no:self.workOrderNoInfo,
                                        amount: data.content.item[i].labor_amount + data.content.item[i].component_amount,
                                        miles: data.content.item[i].miles,
                                        vmrsId: data.content.item[i].vmrs_code_id,
                                    },
                                    po_invoice_from_wo:"sublet_invoice",
                                    create_po_invoice:false,
                                    claim_number:(data.content.item[i].claim_number != undefined && data.content.item[i].claim_number != null && data.content.item[i].claim_number != '') ?
                                        data.content.item[i].claim_number:"",
                                    claim_id:(data.content.item[i].claim_id != undefined && data.content.item[i].claim_id != null && data.content.item[i].claim_id != '') ?
                                        data.content.item[i].claim_id:0,
                                    general_ledger:data.content.item[i].gl,//item-wise gl
                                    program_id:(data.content.item[i].program_id != undefined && data.content.item[i].program_id != null && data.content.item[i].program_id != '') ? {
                                        value: data.content.item[i].program_id,
                                        text: data.content.item[i].program
                                    } : null,
                                    warranty:(data.content.item[i].warranty_id != undefined && data.content.item[i].warranty_id != null && data.content.item[i].warranty_id != '') ? {
                                        value: data.content.item[i].warranty_id,
                                        text: data.content.item[i].warranty
                                    } : null,
                                    unit_no:(data.content.item[i].unit_no != undefined && data.content.item[i].unit_no != null && data.content.item[i].unit_no != '') ?data.content.item[i].unit_no:"",
                                    line_number: (data.content.item[i].line_number != undefined && data.content.item[i].line_number != null && data.content.item[i].line_number != '') ? data.content.item[i].line_number : "",
                                    po_status:(data.content.item[i].po_status != undefined && data.content.item[i].po_status != null && data.content.item[i].po_status != '') ?data.content.item[i].po_status:"",
                                    serial_number:(data.content.item[i].serial_number != undefined && data.content.item[i].serial_number != null && data.content.item[i].serial_number != '') ?data.content.item[i].serial_number:"",
                                    alias_number:(data.content.item[i].alias_number != undefined && data.content.item[i].alias_number != null && data.content.item[i].alias_number != '') ?data.content.item[i].alias_number:"",
                                    labor_amount: (data.content.item[i].labor_amount != undefined && data.content.item[i].labor_amount != null && data.content.item[i].labor_amount != '') ? data.content.item[i].labor_amount : "",
                                    taxamout: (data.content.item[i].taxamout != undefined && data.content.item[i].taxamout != null && data.content.item[i].taxamout != '') ? data.content.item[i].taxamout : "",
                                    inv_line_pst_amount: (data.content.item[i].inv_line_pst_amount != undefined && data.content.item[i].inv_line_pst_amount != null && data.content.item[i].inv_line_pst_amount != '') ? data.content.item[i].inv_line_pst_amount : "",
                                    component_amount:(data.content.item[i].component_amount != undefined && data.content.item[i].component_amount != null && data.content.item[i].component_amount != '') ? data.content.item[i].component_amount : "",
                                });

                                self.serviceTaskArr.push({
                                    value: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '') ? data.content.item[i].task_id : null,
                                    text: data.content.item[i].task_name,
                                    index: self.taskArr.length - 1
                                });
                                for(var j=0;j<self.selecttaskArr.length;j++){
                                    if(data.content.item[i].wo_item_id==self.selecttaskArr[j].itemId)
                                    {
                                            self.taskArr[i]['itemSelection']=true;
                                    }

                                }

                            }
                        }

                        if (data.content.comp != undefined) {
                            for (var i = 0; i < data.content.comp.length; i++) {

                                self.componentArr.push({
                                    cid: (data.content.comp[i].cid != undefined && data.content.comp[i].cid != null && data.content.comp[i].cid != '') ? data.content.comp[i].cid : 0,
                                    compid: {
                                        value: data.content.comp[i].compid,
                                        text: data.content.comp[i].compname
                                    },
                                    service_task_id: {
                                        value: data.content.comp[i].service_task_id,
                                        text: data.content.comp[i].service_task_name,
                                        index: data.content.comp[i].service_task_index
                                    },
                                    compcost: data.content.comp[i].compcost,
                                    compquantity: data.content.comp[i].compquantity,
                                    compsubtotal: data.content.comp[i].compsubtotal,
                                    compdescription: (data.content.comp[i].compdescription != null && data.content.comp[i].compdescription != '') ? data.content.comp[i].compdescription : "-",
                                    estimatedcid: (data.content.comp[i].estimate_cid != undefined && data.content.comp[i].estimate_cid != null && data.content.comp[i].estimate_cid != '') ? data.content.comp[i].estimate_cid : 0,
                                    is_issued: data.content.comp[i].is_issued,
                                });

                            }
                        }

                        if (data.content.comment != undefined) {
                            for (var i = 0; i < data.content.comment.length; i++) {

                                self.commentArr.push({
                                    wocId: (data.content.comment[i].wocId != undefined && data.content.comment[i].wocId != null && data.content.comment[i].wocId != '') ? data.content.comment[i].wocId : 0,
                                    service_task_id: {
                                        value: data.content.comment[i].service_task_id,
                                        text: data.content.comment[i].service_task_name,
                                        index: data.content.comment[i].service_task_index
                                    },
                                    wocType: {
                                        value: data.content.comment[i].wocTypeId,
                                        text: self.titleCase(data.content.comment[i].wocTypeName) + ' (' + data.content.comment[i].wocType + ')'
                                    },
                                    woc: data.content.comment[i].woc,
                                    wocBy: data.content.comment[i].wocBy,
                                    wocAt: data.content.comment[i].wocAt,
                                    estimatedwocId: (data.content.comment[i].estimate_wocId != undefined && data.content.comment[i].estimate_wocId != null && data.content.comment[i].estimate_wocId != '') ? data.content.comment[i].estimate_wocId : 0
                                });

                            }
                        }

                        if (data.content.labor != undefined) {
                            for (var i = 0; i < data.content.labor.length; i++) {

                                self.laborArr.push({
                                    lid: (data.content.labor[i].lid != undefined && data.content.labor[i].lid != null && data.content.labor[i].lid != '') ? data.content.labor[i].lid : 0,
                                    laborid: (data.content.labor[i].laborid != undefined && data.content.labor[i].laborid != null && data.content.labor[i].laborid != '') ? {
                                        value: data.content.labor[i].laborid,
                                        text: data.content.labor[i].laborname
                                    } : null,
                                    service_task_id: {
                                        value: data.content.labor[i].service_task_id,
                                        text: data.content.labor[i].service_task_name,
                                        index: data.content.labor[i].service_task_index
                                    },
                                    laborhours: data.content.labor[i].laborhours,
                                    laborhourrate: data.content.labor[i].laborhourrate,
                                    laborsubtotal: data.content.labor[i].laborsubtotal,
                                    labordescription: (data.content.labor[i].labordescription != null && data.content.labor[i].labordescription != '') ? data.content.labor[i].labordescription : "-",
                                });

                                if (data.content.timelog != undefined) {
                                    for (var k = 0; k < data.content.timelog.length; k++) {
                                        if (data.content.timelog[k].lid == data.content.labor[i].lid) {
                                            self.laborHourArr.push({
                                                timelog_id: (data.content.timelog[k].timelogid != undefined && data.content.timelog[k].timelogid != null && data.content.timelog[k].timelogid != '') ? data.content.timelog[k].timelogid : 0,
                                                labor_id: data.content.timelog[k].lid,
                                                start_time: (data.content.timelog[k].start_time != null && data.content.timelog[k].start_time != undefined && data.content.timelog[k].start_time != '') ? data.content.timelog[k].start_time : '-',
                                                end_time: (data.content.timelog[k].end_time != null && data.content.timelog[k].end_time != undefined && data.content.timelog[k].end_time != '') ? data.content.timelog[k].end_time : '-',
                                                duration: (data.content.timelog[k].duration != null && data.content.timelog[k].duration != undefined && data.content.timelog[k].duration != '') ? data.content.timelog[k].duration : '-',
                                                labor_index: i,
                                                service_task_index:data.content.timelog[k].service_task_index,
                                                labor_name:data.content.timelog[k].laborname,
                                            });
                                        }

                                    }
                                }

                            }
                        }

                        //crm activity for work order
                        if (data.content.activity != undefined) {
                            for (var i = 0; i < data.content.activity.length; i++) {

                                self.activityArr.push({
                                    woiId: (data.content.activity[i].woiId != undefined && data.content.activity[i].woiId != null && data.content.activity[i].woiId != '') ? data.content.activity[i].woiId : 0,
                                    crmId: (data.content.activity[i].crmId != undefined && data.content.activity[i].crmId != null && data.content.activity[i].crmId != '') ? data.content.activity[i].crmId : 0,
                                    service_task_index: data.content.activity[i].service_task_index,
                                    activity_type: data.content.activity[i].activity_type,
                                    notes: (data.content.activity[i].notes != null && data.content.activity[i].notes != undefined && data.content.activity[i].notes != '') ? data.content.activity[i].notes : '',
                                    activityBy: data.content.activity[i].activityBy,
                                    activityAt: data.content.activity[i].activityAt,
                                });
                            }
                        }
                        //final General Ledger Arr
                        if (data.content.gl != undefined) {
                            self.gl_data_success = true;
                            self.glArr = data.content.gl;
                        }
                        //Tax Exempt Message
                        if (data.content.tax_exempt != undefined && data.content.tax_exempt != null) {
                            self.tax_exempt = data.content.tax_exempt;
                        }
                        if (data.content.line_sequence != undefined && data.content.line_sequence != null) {
                            self.lineSequence = data.content.line_sequence;
                        }

                    } else if (data.code == 201) {

                        console.log('No line item is assigned with wo..')

                    }
                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'get-workorder-items-view');
                }
            });
        },

        selectionForEstimation: function (evt, item, index) {
            var self = this;
            if (evt.target.checked == true) {
                if (item.vendorid && item.vendorid.value) {

                    self.selecttaskArr.push({
                        itemId: item.woiId,
                        sublet: item.issublet,
                        vendorId: item.vendorid.value,
                        poId:item.purchaseorderid,
                        vendor_est_item_id:item.vendor_est_item_id,
                        cust_est_item_id:item.cust_est_item_id,
                        cust_est_id:item.cust_est_id,
                        sublet_amount:item.sublet_amount
                    });

                } else {

                    self.selecttaskArr.push({itemId:item.woiId,sublet:item.issublet,poId:item.purchaseorderid,cust_est_item_id:item.cust_est_item_id,sublet_amount:item.sublet_amount});

                }
            } else {
                // var i = self.selecttaskArr.indexOf(item.woiId);
                // console.log(i);
                const filteredItems = self.selecttaskArr.filter(function (task) {
                    return task.itemId !== item.woiId;
                })
                self.selecttaskArr = filteredItems;
            }
            console.log(self.selecttaskArr);

        },
        generateEstimation: function (flag) {

            var self = this;
            var arr = [];
            var url = '';
            var error = false;

            if (flag == 'vendor') {
                var vendId = 0;
                self.selecttaskArr.forEach(function (item) {

                    if (vendId != 0 && vendId != item.vendorId) {

                        self.$swal('', 'Please select item with same vendor', 'info');

                    }else if(item.poId != '-' && item.poId.value && item.poId.value != ''){

                        self.$swal('','Purchase order already available','info');

                        error = true;
                    }else{

                        vendId = item.vendorId;
                    }

                    if (item.sublet == 1) {

                        arr.push({
                            itemId: item.itemId
                        });
                    }
                });

                url = '/generate-vendor-estimation';
                if (arr.length == 0) {
                    error = true;
                    self.$swal('', 'No Item with sublet is selected', 'info');

                }
            } else {

                self.selecttaskArr.forEach(function (item) {

                    arr.push({
                        itemId: item.itemId
                    });
                });

                url = '/generate-customer-estimation';
            }

            var field = [];

            field.push({
                name: 'items',
                value: JSON.stringify(arr)
            });
            field.push({
                name: 'woId',
                value: self.work_order_id
            });

            if (!error) {

                $.ajax({
                    url: process.env.ROOT_API + url,
                    type: "POST",
                    data: field,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.code == 201 && flag == 'customer') {

                            self.$swal('', data.content, 'info');
                            return;
                        }
                        if (data.code == 200 && flag == 'customer') {

                            self.$router.push('/customer-estimate/edit/' + data.content + "?flag=main");

                        }

                        if (data.code == 201 && flag == 'vendor') {

                            self.$swal('', data.content, 'info');

                            return;

                        }

                        if (data.code == 200 && flag == 'vendor') {

                            self.$router.push('/vendor-estimate/edit/' + data.content + "?flag=main");

                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, true, 'generate-customer-or-vendor-estimate');
                    }
                });
            }
        },
        titleCase(str) {
            if (str == null) {
                return "-";
            } else {
                var value = str.toString();
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },
        amountFormat(amount) {

            return Number(amount).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
        },
        activityLogs(){

          var self = this;

          self.$root.$emit('activity_log_opted','work order',self.work_order_id);
          self.activityLogsTabValue = "woloadList";     // flag value set to loadList so that filters in list work properly.
          self.activetab = 2;
        },
        createEstimate(flag) {

            var self = this;
            var error = false;
            var arr = [];
            // var path = window.location.pathname;
            // var segments = path.split("/");

            if (flag == 'vendor') {
                var vendId = 0;
                var itemId = '';

                if( self.selecttaskArr.length > 0 ){

                    self.selecttaskArr.forEach(function (item) {
                        console.log(item);
                        if (vendId != 0 && vendId != item.vendorId) {

                            error = true;
                            self.$swal('', 'Please select item with same vendor', 'info');
                            // return;

                        }else if(item.poId != '-' && item.poId.value && item.poId.value != ''){

                            error = true;
                            self.$swal('','Purchase order already available','info');
                            // return;


                        }else if(item.vendor_est_item_id && item.vendor_est_item_id != undefined && item.vendor_est_item_id != 0){

                            error = true;
                            self.$swal('','Estimation already created','info');
                            // return;

                        }else{

                            vendId = item.vendorId;
                        }

                        if (item.sublet == 1) {

                            if ( itemId != ''){

                                itemId += ','+item.itemId
                            }else{

                                itemId = item.itemId;
                            }
                            arr.push({
                                itemId: item.itemId
                            });
                        }
                    });

                    if (arr.length == 0) {
                            error = true;
                            self.$swal('', 'No Item with sublet is selected', 'info');

                    }
                    if ( !error ) {



                        var url = '&woId='+self.work_order_id+'&woItemId='+itemId+'&redirectFrom=WorkOrderView';

                        // self.$router.push()
                        self.$router.push({ name: 'VendorEstimateCreate', query: { data : btoa(url) }});
                    }
                }else if(!self.taskArr.length){

                        self.$swal('','Vendor Estimate cannot be created without any line item added !','info');
                }else{
                    var arr = [];
                    var error = false;
                    self.taskArr.forEach(function (item) {

                        if (item.issublet == 1) {
                            arr.push({
                                itemId: item.wo_item_id
                            });
                        }

                        if (arr.length == 0) {
                                error = true;
                                self.$swal('', 'No sublet item selected', 'info');
                        }
                    });
                    if (error){
                        return;
                    }
                    if ( self.venEstGenerated != 'true' ) {

                        if (confirm('You want to create Estimate without line item? ')) {

                            var url = '&woId='+self.work_order_id+'&woItemId='+0+'&redirectFrom=WorkOrderView';

                            // self.$router.push()
                            self.$router.push({ name: 'VendorEstimateCreate', query: { data : btoa(url) }});
                            return;
                        }

                    }else{

                        self.$swal('','Vendor Estimate already created','info');
                    }
                }


            } else {
                var itemId = '';
                if( self.selecttaskArr.length > 0 ){
                    self.selecttaskArr.forEach(function (item) {

                        if((item.cust_est_item_id && item.cust_est_item_id != undefined && item.cust_est_item_id != 0) || (item.cust_est_id && item.cust_est_id != undefined && item.cust_est_id != 0)){

                            error = true;
                            self.$swal('','Customer Estimation already created','info');
                            // return;

                        }

                        arr.push({
                            itemId: item.itemId
                        });
                        if ( itemId != ''){

                            itemId += ','+item.itemId
                        }else{

                            itemId = item.itemId;
                        }
                    });

                    if ( !error ) {

                        var url = '&woId='+self.work_order_id+'&woItemId='+itemId+'&redirectFrom=WorkOrderView';

                        // self.$router.push()
                        self.$router.push({ name: 'CustomerEstimateCreate', query: { data : btoa(url) }});
                    }
                }else if(!self.taskArr.length){

                        self.$swal('','Customer Estimate cannot be created without any line item added !','info');
                }else{

                    if ( !error){

                        if (self.custEstGenerated != 'true'){

                            if (confirm('You want to create Estimate without line item? ')) {

                                var url = '&woId='+self.work_order_id+'&woItemId='+0+'&redirectFrom=WorkOrderView';

                                // self.$router.push()
                                self.$router.push({ name: 'CustomerEstimateCreate', query: { data : btoa(url) }});
                            }

                        }else{
                            self.$swal('','Customer Estimate already created','info');
                        }
                    }

                }
            }
        },
        createPurchaseOrder: function(flag){

            var self = this;
            var vendId = 0;
            var itemId = '';
            var error = false;

            var arr =[];
            if(self.selecttaskArr.length > 0){
                if (self.selecttaskArr.length > 1) {
                    error = true;
                    self.$swal('', 'Please select one item', 'info');
                    return;
                }

                self.selecttaskArr.forEach(function (item) {
                    console.log(item);
                    if (!item.vendorId){
                        error = true;
                        self.$swal('', 'Please select vendor', 'info');
                    }
                    if (vendId != 0 && vendId != item.vendorId) {

                        self.$swal('', 'Please select item with same vendor', 'info');
                        // return;

                    }else if(item.poId != '-' && item.poId.value && item.poId.value != ''){

                        error = true;
                        self.$swal('','Purchase order already available','info');
                        // return;


                    }
                    else if( (item.poId == '-' || item.poId.value == '') && (item.sublet_amount == null || item.sublet_amount == 0)){
                        error = true;
                        self.$swal('','Please Enter Sublet Amount','info');
                        // return;

                    }
                    else{

                        vendId = item.vendorId;
                    }

                    if (item.sublet == 1) {

                        if ( itemId != ''){

                            itemId += ','+item.itemId
                        }else{

                            itemId = item.itemId;
                        }
                        arr.push({
                            itemId: item.itemId
                        });
                    }
                });
                if (arr.length == 0) {

                        self.$swal('', 'No Item with sublet is selected', 'info');
                        error = true;
                }

                if ( !error ) {

                    var url = '&woId='+self.work_order_id+'&woItemId='+itemId+'&redirectFrom=WorkOrderView';

                    self.$router.push({ name: 'VendorPurchaseOrderCreate', query: { data : btoa(url) }});
                }

            }else if(!self.taskArr.length){

                self.$swal('','Purchase order Cannot be create without any line item added','info');
            }else{

                var arr = [];
                var error = false;
                self.taskArr.forEach(function (item) {

                    if (item.issublet == 1) {
                        arr.push({
                            itemId: item.wo_item_id
                        });
                    }

                    if (arr.length == 0) {
                            error = true;
                            self.$swal('', 'No sublet item selected', 'info');
                    }
                });
                if (error){
                    return;
                }

                if (self.poGenerated != 'true'){

                    if (confirm('Are you sure that you want to remove file? ')) {
                        var url = '&woId='+self.work_order_id+'&woItemId=0'+'&redirectFrom=WorkOrderView';

                        // self.$router.push()
                        self.$router.push({ name: 'VendorPurchaseOrderCreate', query: { data : btoa(url) }});
                        return;
                    }

                }else{

                    self.$swal('','Purchase order already generated','info');
                }

            }

        },
        updateSubletAmount:function(item,index){
            var self = this;

// console.log(item);
// return;
            var checkNumber = /^[0-9]+(\.[0-9]+)?$/;
            var amount = $("#subletAmount"+index).val();

            var amount_error_msg = '';
            $("subletError"+index).text('');
            // alert(amount);
            if ( amount == '' || amount == null || amount == 0){

                var amount_error_msg = 'Sublet amount required';

                $("#subletError"+index).text(amount_error_msg);

            }
            if (!String(amount).match(checkNumber)) {
                amount_error_msg = "Sublet amount is not valid.";
                // error = true;
                $("#subletError"+index).text(amount_error_msg);
            }


            if ( amount_error_msg == ''){

                self.loading = true;
                // setTimeout(function(){
                //     $("#itemIndex"+index).attr('disabled', true);
                // },50);

                $.ajax({
                    url: process.env.ROOT_API + '/store-sublet-amount',
                    type: "POST",
                    data: {
                        item_id:item.woiId,
                        amount:amount
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // self.taskArr[index].sublet_amount = amount;
                        self.$set(self.taskArr[index], 'sublet_amount', amount);

                        setTimeout(function(){
                            if ($('#itemIndex'+index).is(':checked')){

                                setTimeout(function(){
                                    // $("#itemIndex"+index).prop( "checked",false );
                                    $("#itemIndex"+index).trigger('click');
                                },100);
                                setTimeout(function(){
                                    // $("#itemIndex"+index).prop( "checked", true );
                                    $("#itemIndex"+index).trigger('click');
                                },200);
                            }
                        },100);
                        // if (self.selecttaskArr.length){
                        //     self.selecttaskArr[index].sublet_amount = amount;
                        // }
                        // self.workOrderItemData();

                        // setTimeout(function(){
                        //     $("#itemIndex"+index).attr('disabled',false);
                        // },1000);
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, true, 'store-sublet-amount');
                    }
                });
            }
        },
        generatePurchaseOrder: function(woId,items){

            var self = this;

            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + '/purchase-order-generate',
                type: "POST",
                data: {
                    items:items,
                    wo_id:woId
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.code == 200){

                        self.$router.push("/vendor-purchase-order/view/" + data.content.id);
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'generate-purchase-order');
                }
            });
        },
        updateAmountBlock: function(index){
            var self = this;


            // alert(self.taskArr[index].sublet_amount);
            // $("#subletAmount"+index).val(self.taskArr[index].sublet_amount);
            self.taskArr[index].inset_sublet_amount = self.taskArr[index].sublet_amount;

            self.taskArr[index].sublet_amount = null;

            // $("#subletAmountSpace"+index).show();
        },
        generateInvoice(){
            var self = this;

            if (confirm('Do you want to generate Invoice? ')) {
                self.$router.push({ name: 'WorkOrderInvoiceCreate', query: { work_order_id : self.work_order_id }});
                return;
            }

        },
        print(flag) {

            var self = this;
            var url = '&work_order_id='+self.work_order_id+'&flag='+flag+"&frmUrl="+window.location.pathname+window.location.search;
            self.$router.push({ name: 'WorkOrderPreview', query: { data : btoa(url) }});
        },
        //generate vendor invoice from po
        generatePOInvoice(woItem,index){
            var self = this;

            for (var i = 0;i < self.taskArr.length;i++) {
                if (self.taskArr[i] != undefined) {
                    if (self.taskArr[i] != null) {
                        if (i == index) {
                            if (self.taskArr[i].create_vendor_invoice == 0) {
                                self.$set(self.taskArr[i], 'create_vendor_invoice',1);
                                if (self.taskArr[i].po_id != null && self.taskArr[i].po_id != 0) {
                                    var poObj = {
                                        poId:self.taskArr[i].po_id,
                                        woItemId:self.taskArr[i].po_id,
                                        billId:self.taskArr[i].bill_id,
                                        type:"sublet_invoice",
                                        wo_type:self.woType
                                    };
                                    // self.$set(self.taskArr[i], 'po_data_from_wo',poObj);
                                    self.$set(self.taskArr[i], 'create_po_invoice',true);
                                }else{
                                    var poObj = {
                                        poId:self.taskArr[i].po_id,
                                        woItemId:self.taskArr[i].po_id,
                                        billId:self.taskArr[i].bill_id,
                                        type:"sublet_invoice",
                                        wo_type:self.woType
                                    };
                                    // self.$set(self.taskArr[i], 'po_data_from_wo',poObj);
                                    self.$set(self.taskArr[i], 'create_po_invoice',false);
                                }
                            }else{
                                self.$set(self.taskArr[i], 'create_vendor_invoice',0);
                                var poObj = {
                                    poId:self.taskArr[i].po_id,
                                    woItemId:self.taskArr[i].po_id,
                                    billId:self.taskArr[i].bill_id,
                                    type:"sublet_invoice",
                                    wo_type:self.woType
                                }
                                // self.$set(self.taskArr[i], 'po_data_from_wo',poObj);
                                self.$set(self.taskArr[i], 'create_po_invoice',false);
                            }
                        }else{
                            self.$set(self.taskArr[i], 'create_vendor_invoice',0);
                            var poObj = {
                                poId:self.taskArr[i].po_id,
                                woItemId:self.taskArr[i].po_id,
                                billId:self.taskArr[i].bill_id,
                                type:"sublet_invoice",
                                wo_type:self.woType
                            }
                            // self.$set(self.taskArr[i], 'po_data_from_wo',poObj);
                            self.$set(self.taskArr[i], 'create_po_invoice',false);
                        }
                    }
                }
            }
        },
        hideInvoicePOForm(){
            var self = this;
            if (self.woType != '' && self.woType == 'multi unit'){
                self.createHeaderInvoice = false;
            }else{
                for(var i = 0;i< self.taskArr.length;i++) {
                    if (self.taskArr[i] != undefined) {
                        if (self.taskArr[i] != null) {
                            if (self.taskArr[i].create_vendor_invoice == 1) {
                                self.$set(self.taskArr[i], 'create_vendor_invoice',0);
                                if (self.taskArr[i].create_po_invoice) {
                                    self.$set(self.taskArr[i], 'create_po_invoice',false);
                                }
                            }
                        }
                    }
                }
            }
        },
        verifyVendorInvoice(woItem,index,invStatus) {
            var self = this;
            console.log("verifyVendorInvoice");
            if (woItem != undefined) {
                if (woItem != null) {
                    if (woItem.bill_id != undefined) {
                        if (woItem.bill_id != null) {
                            console.log(woItem.bill_id);
                            var message = 'Are you sure that you want to verify the Vendor Invoice? ';
                            if (invStatus == 'entered') {
                                message = 'Are you sure that you want to unverify the Vendor Invoice? ';
                            }
                            // if (confirm('Are you sure that you want to verify the Vendor Invoice? ')) {
                            if (confirm(message)) {
                                var idArr = [];
                                idArr.push(woItem.bill_id);
                                self.loading = true;
                                $.ajax({
                                    url: process.env.ROOT_API + "/bill/change-status",
                                    type: "POST",
                                    // data: {arr:idArr,status:"verified"},
                                    data: {arr:idArr,status:invStatus},
                                    headers: this.ajxHeaders,
                                    dataType: "json",
                                    success: function (data) {
                                        self.loading = false;
                                        if (data.status == "success") {
                                            self.loadWorkOrderDetail();
                                        }
                                    },
                                    error: function (jqXHR, exception) {
                                        self.loading = false;
                                        self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-change-status-wo');
                                    }
                                });
                            }
                        }
                    }
                }
            }
        },
        editVendorPO(poId,index) {
            var self = this;
            console.log(poId);
            if (poId != undefined && poId != null && poId > 0) {
                // let routeData = self.$router.resolve({ name:"VendorPurchaseOrderEdit",params:{ id: poId}});
                // window.open(routeData.href,"_blank");
                self.$router.push({name: 'VendorPurchaseOrderEdit',params:{id:poId,from:'woView',woId:self.work_order_id}});
            }
        },
        addClaim:function(index){
            var self = this;

            // self.create_warranty_claim = true;
            for (var i = 0;i < self.taskArr.length;i++) {
                if (self.taskArr[i] != undefined) {
                    if (self.taskArr[i] != null) {
                        if (i == index) {
                            if (self.taskArr[i].create_warranty_claim == 0) {
                                self.$set(self.taskArr[i], 'create_warranty_claim',1);

                            }else{
                                self.$set(self.taskArr[i], 'create_warranty_claim',0);

                            }
                        }else{
                            self.$set(self.taskArr[i], 'create_warranty_claim',0);
                        }
                    }
                }
            }
        },
        updateWoiFields: function (complaint,cause,correction,woiId) {
          var self = this;
          var field = [];

          field.push({
            name: 'complaint',
            value: complaint,
          });
          field.push({
            name: 'cause',
            value: cause,
          });
          field.push({
            name: 'correction',
            value: correction,
          });
          field.push({
            name: 'woiId',
            value: woiId,
          });
          $.ajax({
            url: process.env.ROOT_API + '/workorder/update-wo-item-fields',
            type: "POST",
            data: field,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
              self.loading = false;
              $("#updateWorkOrderItemFieldModal").modal('hide');
              self.loadWorkOrderDetail();
            },
            error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR, true, 'generate-customer-or-vendor-estimate');
            }
          });
        },
        showCommentsEditModal: function(woiId,complaint,cause,correction){
          var self = this;
          self.complaint = complaint;
          self.cause = cause;
          self.correction = correction;
          self.currentWoiId = woiId;
          $("#updateWorkOrderItemFieldModal").modal('show');
        },
        cancelWarrantyClaim:function(){
            var self=this;
            for(var i = 0;i< self.taskArr.length;i++) {
                if (self.taskArr[i] != undefined) {
                    if (self.taskArr[i] != null) {
                        if (self.taskArr[i].create_warranty_claim == 1) {
                            self.$set(self.taskArr[i], 'create_warranty_claim',0);
                            if (self.taskArr[i].create_warranty_claim) {
                                self.$set(self.taskArr[i], 'create_warranty_claim',false);
                            }
                        }
                    }
                }
            }
        },
        updateClaimAmountBlock:function(claimId){
            var self = this;
            self.create_warranty_claim = true;
            self.setFlagClaim = 'update';
        },
        backWorderList() {
            var self = this;
             var url = "/workorder/list";
            if ( self.fromUrl != "" && self.fromUrl != null ) {
              if(self.$route.query.from == 'assetView'){
                url = self.fromUrl+'?viewTab=workOrder';
              }else{
                url = self.fromUrl;
              }

            }else if ( self.$route.query.from != undefined && self.$route.query.from == "gl") {
                url = "/report/general-ledger";
            }
            self.redirectPageUrl(url);
           // self.$router.push("/workorder/list");
        },
        crmSection() {
            var self = this;
            if (!self.isCrmSection) {
                self.isCrmSection = true;
                self.enableWOCrm = true;
                self.crmBtnTitle = "Detail";
            }else{
                self.isCrmSection = false;
                self.enableWOCrm = false;
                self.crmAdd = false;
                self.crmBtnTitle = "CRM";
            }
        },
        addCrm() {
            var self = this;
            self.crmAdd = true;
            self.workOrderObj.crm_id = "";
            self.workOrderObj.flag = "add";
        },
        cancelCrmFromView() {
            var self = this;
            self.crmAdd = false;
        },
        editCrmFromView(crmId){
            var self = this;
            self.crmAdd = true;
            self.workOrderObj.crm_id = crmId;
            self.workOrderObj.flag = "update";
        },
        viewCustomerInvoice(){
            var self = this;
            if (self.invoice_id != null && self.invoice_id != "") {
                var url = self.$router.resolve("/invoice/wo/view/" + self.invoice_id+"?fromUrl="+btoa(window.location.pathname+window.location.search));
                window.open(url.href, '_blank');
            }
        },
        // openCloseLine:function(){
        //     var self = this;
        //     alert('hi')
        //     self.create_warranty_claim = false;
        // }
        showmodel(){
            $("#select-date").modal("show");
        },
        hideModal: function(){
          $("#sipAdjustModel").modal("hide");
        },
        openModal: function(){
          $("#sipAdjustModel").modal("show");
        },
        makeModalDisable: function(){
          this.modelDisabled = true;
        },
        makeModalEnable: function(){
          this.modelDisabled = false;
      },
        onSearchAccount(search, loading) {
          var self = this;
          if (search.length > 3) {

            loading(true);
            self.searchField(loading, search, 'accounts', '');

          }
        },
        // onDebitInput($event,index) {
        //   const self = this;
        //   if (self.rows[index].debit.trim() === "") {
        //     self.rows[index].debitDisabled = 0;
        //     self.rows[index].creditDisabled = 0;
        //   }else{
        //     self.rows[index].creditDisabled = 1;
        //   }
        // },
        // onCreditInput($event,index) {
        //   const self = this;
        //   if (self.rows[index].credit.trim() === "") {
        //     self.rows[index].debitDisabled = 0;
        //     self.rows[index].creditDisabled = 0;
        //   }else{
        //     self.rows[index].debitDisabled = 1;
        //   }
        // },
        onChangeTransactionDate:function(newDate){
          const self = this;
          const date = new Date(newDate);
          const formattedDate = new Intl.DateTimeFormat('en', { month: '2-digit', year: 'numeric' }).format(date);
          self.fiscal_date = formattedDate
        },
        getSectionForReading:function(vehicleId,ttid,uid){

            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/section-by-truck-type/fetch",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    vehicle_type_id:ttid,
                    vehicle_id:vehicleId,
                    unit_no:uid
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.sectionArr = data.content;

                        for (let i = 0; i < self.sectionArr.length; i++) {
                            self.sectionArr[i].reading = self.sectionArr[i].reading === '' ? self.existingReading[i] : self.sectionArr[i].reading;
                            if(self.sectionArr[i].read_on_wo == "mandatory"){
                              self.sectionArr[i].class = "form-inline form-control";
                              if (self.sectionArr[i].reading == null || self.sectionArr[i].reading == "" || self.sectionArr[i].reading == 0) {
                                self.sectionArr[i].class = "form-inline form-control border-red";
                              }
                            }
                        }

                        // self.taskArr[index].warrantyArr = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-section');
                }
            });

        },
        closeWOItem() {


            var self = this;

            // self.date
            // self.$swal({
            //     title: 'Are you sure that you want to Close WO Items?',
            //     type: 'info',
            //     showCancelButton: true,
            //     confirmButtonText: 'Yes',
            //     cancelButtonText: 'No',
            //     showCloseButton: false,
            //     showLoaderOnConfirm: true,
            //     allowOutsideClick:false,
            //     html:'Selected Date : <input id="datepicker" class="form-control">',
            //     customClass: 'swal2-overflow',
            //     onOpen:function(){
            //         setTimeout(function () {
            //         $('#datepicker').datepicker({
            //         dateFormat: 'dd/mm/yy HH:mm:ss',
            //         autoclose: true
            //         }).datepicker("setDate",  new Date());
            //     },400);
            //     },
            // }).then((result) => {
            //     if (result.value) {
            //         console.log(result.value);
                    //check for reading first
                    self.addMiles = false;
                    if (self.assetRequired && !self.showMiscellaneousFields) {
                        if (self.sectionArr.length){
                          console.log('self.sectionArr = ', self.sectionArr)
                            for(var j=0;j < self.sectionArr.length;j++){
                                self.sectionArr[j].class = "form-inline form-control";
                                if (self.sectionArr[j].reading < 0 || self.sectionArr[j].reading == '' || self.sectionArr[j].reading == null){
                                    //to enable input for enter reading
                                    $("#select-date").modal("hide");
                                    self.addMiles = true;
                                }
                            }
                        }
                    }
                    if (!self.showSaveButton){
                      self.addMiles = false;
                    }
                    if (!self.addMiles) {
                        self.outOfServiceCall();
                    }else{
                        //scroll work order details div
                        document.getElementById("workorder-detail-tabs").scrollIntoView({
                            block: "end",
                            behavior: "smooth"
                        });
                        if (self.sectionArr.length){
                            for(var k = 0; k < self.sectionArr.length; k++ ){
                              if(self.sectionArr[k].read_on_wo == "mandatory"){
                                self.sectionArr[k].class = "form-inline form-control";
                                if (self.sectionArr[k].reading == null || self.sectionArr[k].reading == "" || self.sectionArr[k].reading == 0) {
                                  self.sectionArr[k].class = "form-inline form-control border-red";
                                }
                              }
                            }
                        }
                    }
            //     } else {

            //     }
            // });
        },
        closeWOItemAPI(oosFlag) {
            var self = this;
            self.loading =  true;

            if ( self.requestInProgress == true ) {
                console.log("request in process");
                return;
            }
            self.requestInProgress = true;

            $.ajax({
                url: process.env.ROOT_API + "/work-order-items/close",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    id:self.work_order_id,
                    oos:oosFlag,
                    closedate:self.date
                },
                success: function (data) {
                    self.loading =  false;
                    self.requestInProgress = false;
                    if (data.status == "success") {
                        $("#select-date").modal("hide");
                        self.$swal('',data.message,'success');
                    }else{
                        self.$swal('',data.message,'info');
                    }
                    self.loadWorkOrderDetail();

                },
                error: function (jqXHR, exception) {
                    self.loading =  false;
                    self.requestInProgress = false;
                    $("#select-date").modal("hide");
                    self.generateStatusCodeMessage(jqXHR, false, 'close-wo-items');
                    self.loadWorkOrderDetail();
                }
            });
        },

        checkSectionReading(){
          return new Promise((resolve, reject) => {
            var self = this;
            var fields_err = [];
            if (self.sectionArr.length != undefined){
                for(var j=0;j<self.sectionArr.length;j++){
                    self.sectionArr[j].reading_error = '';
                    if(self.sectionArr[j].reading != '' && (self.sectionArr[j].reading < self.sectionArr[j].lastreading)){
                        var read_error = self.sectionArr[j].section +' : '+'Reading ' +  self.sectionArr[j].reading + ' is less than previous reading ' + self.sectionArr[j].lastreading;
                        fields_err.push(read_error);
                    }
                }
                if(fields_err.length != 0){
                    var fielderror = "";
                    for(var i = 0; i < fields_err.length; i++){
                        fielderror += "<span style='display: contents;font-size: 15px;font-weight: 300;'>" + fields_err[i] +"</span>" + "<br/>";
                    }
                    self.$swal({
                        title: fielderror + "Do you want to continue?",
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        showCloseButton: false,

                        // showLoaderOnConfirm: true,
                        customClass: 'swal2-overflow',
                    }).then((result) => {

                        if (result.value) {
                          resolve(true);
                        } else {
                          resolve(false);
                        }
                    });
                }else{
                  resolve(true);
                }
            }else{
              resolve(true);
            }
          });
        },

        saveMiles(){
            var self = this;
            var error = false;
            var dataArray = [];
            if (self.sectionArr.length){
                for(var k = 0; k < self.sectionArr.length; k++ ){
                    self.sectionArr[k].class = "form-inline form-control";
                    if(self.sectionArr[k].read_on_wo == "mandatory"){
                      dataArray.push(self.sectionArr[k])
                      if (self.sectionArr[k].reading == null || self.sectionArr[k].reading == "" || self.sectionArr[k].reading == 0) {
                        self.sectionArr[k].class = "form-inline form-control border-red";
                        error = true;
                      }
                    }
                }
            }

            self.checkSectionReading().then((result) => {
              if (!error && result) {
                  self.loading = true;
                  $.ajax({
                      url: process.env.ROOT_API + "/workorder/add-miles",
                      type: "POST",
                      data: {
                          'wo_id': self.work_order_id,
                          'woMiles':JSON.stringify(dataArray),
                      },
                      headers: this.ajxHeaders,
                      dataType: "json",
                      success: function (data) {
                          self.loading = false;
                          if (data.status == "success") {
                              self.addMiles = false;
                              self.outOfServiceCall();
                          }

                      },
                      error: function (jqXHR, exception) {
                          self.loading = false;
                          self.generateStatusCodeMessage(jqXHR, true, 'save-miles');
                      },
                  });
              }
            });

        },
        outOfServiceCall() {
            var self = this;
            var oos = 'false';
            if (self.OutOfService != '' && self.OutOfService == 'yes'){
                $("#select-date").modal("hide");
                self.$swal({
                    title: "This Unit is currently Out Of Service",
                    text: "Please select to place in service",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Place In Service",
                    cancelButtonText: "Leave Out Of Service",
                    showCloseButton: true,
                    showLoaderOnConfirm: false,
                    allowOutsideClick:false
                }).then(result => {
                    if (result.value) {
                        oos = 'end';
                        self.closeWOItemAPI(oos);
                    } else if (result.dismiss == 'cancel') {
                        oos = 'false';
                        self.closeWOItemAPI(oos);
                    }else {
                        oos = 'false';
                        return;
                    }
                });
            }else{
                self.closeWOItemAPI(oos);
            }
        },
        billDelete(woItem,index) {
            console.log(woItem.bill_id);
            //var data = this.$refs['listBillTable'].selectedRows;
            var self = this;
            var billId = '';
            self.$swal({
                    title: 'Are you sure that you want to delete this Vendor Invoice?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.action = 'delete';
                        var use = [woItem.bill_id];
                        self.loading = true;

                        $.ajax({
                            url: process.env.ROOT_API + "/bill/delete",
                            type: "POST",
                            data: 'id=' + use,
                            headers: this.ajxHeaders,
                            dataType: "json",
                            cors: true,
                            success: function (data) {
                                self.loading = false
                                self.loadWorkOrderDetail();
                            },
                        });
                    } else {
                      console.log("no");
                    }
                });
        },
        approveWorkOrder:function(){
            var self = this;

            self.$swal({
                title: 'Are you sure that you want to approve this Work Order?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {

                    self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/work-order/approve",
                        type: "POST",
                        data: {
                            wo_id:self.work_order_id,
                            close_date:self.closeDateInfo
                        },
                        headers: this.ajxHeaders,
                        dataType: "json",
                        cors: true,
                        success: function (data) {
                            self.loading = false;
                            if ( data.code == "201" ) {
                                if ( data.wo_arr != "" ) {
                                    // self.woSubMessage = data.wo_arr;
                                    self.$swal('','Please approve vendor invoice.','info');
                                    return;
                                }
                                if ( data.wo_req_po != "" ) {
                                    // self.woPOMessage = data.wo_req_po;
                                    self.$swal('','PO# is required for the customer.','info');
                                    return;
                                }
                                if ( data.wo_num != "" ) {
                                    self.message = 'Wo approve limit exeeds for the WO ' + data.wo_num + '. which is more than ' + data.user_wo_approval_limit;
                                    self.$swal('',self.message,'info');
                                    return;
                                }

                            } else {
                              if("unapproved_wo" in data.content){
                                if (data.content.unapproved_wo.length > 0){
                                  var msg = "Work order could not be approved because it has open work order line items";
                                  self.$swal('',msg,'error');
                                  return;
                                }
                              }
                              self.loadWorkOrderDetail();
                              return;
                            }
                        },
                    });
                } else {
                    console.log("no");
                }
            });
        },
        nextWorkOrder: function(){
            var self = this;

            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/work-order/next",
                type: "GET",
                data: {
                    wo_id:self.work_order_id,
                    batch:self.$route.query.batch
                },
                headers: this.ajxHeaders,
                dataType: "json",
                cors: true,
                success: function (data) {
                    self.loading = false
                    if ( data.code == "201" ) {
                        self.$swal('',data.message,'info');
                    } else {
                        self.$router.push('/workorder/view/'+data.content.id+'?batch='+data.content.batch);
                    }
                },
            });
        },
        changeTabStatus: function (tab) {
          const self = this;
          self.detail_tab = tab
          if (tab === 1) {
            self.line_details = 'active';
            self.gl_details = '';
            self.adjustment = '';
            localStorage.setItem('wo_view_tab', 'line_details');
          } else if (tab === 2) {
            self.line_details = '';
            self.gl_details = 'active';
            self.adjustment = '';
            localStorage.setItem('wo_view_tab', 'gl_details');
          } else if(tab === 3) {
            self.getSipApglData();
            self.line_details = '';
            self.gl_details = '';
            self.adjustment = 'active';
            localStorage.setItem('wo_view_tab', 'adjustment');
          }
        },
        
        getSipApglData: function () {
          const self = this;
          self.loading = true;

          self.found_uuu = '';

          $.ajax({
            url: process.env.ROOT_API + "/workorder/get-workorder-sip-apgl",
            type: "GET",
            data: {
              workOrderId: self.work_order_id,
            },
            headers: this.ajxHeaders,
            dataType: "json",
            cors: true,
            success: function (data) {
              self.loading = false;

              if (data.content.show_adjust_sip_btn) {
                if (data.content.transaction_date != null) {
                  const transactionDate = new Date(data.content.transaction_date);
                  self.post_date = transactionDate.toISOString().split('T')[0]
                  self.transaction_date = transactionDate.toISOString().split('T')[0];
                  const month = transactionDate.getMonth() + 1;
                  const year = transactionDate.getFullYear();
                  self.fiscal_date = month + ' / ' + year;
                }
              }

              self.account_payable = data.content.account_payable
              self.general_ledger = data.content.general_ledger
              self.sublet_adjustment = data.content.sublet_adjustment
              self.sip_amount = data.content.sip_difference
              self.found_uuu = data.content.found_uuu
              self.gl_account = data.content.general_ledger.gl_code

              self.gl_account_id = data.content.general_ledger.gl_account_id
              self.gl_account_name = data.content.general_ledger.gl_code+data.content.general_ledger.gl_account
              self.show_adjust_sip_btn = data.content.show_adjust_sip_btn
              self.show_adjust_tab = data.content.show_adjust_tab
              
              if ( data.content.account_payable ) {
                self.is_account_payable = true;
                self.adjustment_data_success = true;
              }

              if ( data.content.general_ledger ) {
                self.is_general_ledger = true;
                self.adjustment_data_success = true;
              }

              if ( self.sublet_adjustment ) {
                self.is_sublet_adjustment = true;
              }

              self.rows[0].debit = Math.abs(data.content.sip_difference)
              self.rows[1].credit = Math.abs(data.content.sip_difference)

            },
            error: function (jqXHR, exception) {
              self.loading = false;
            },
          });
        },
        createGlForSip: function () {
          const self = this;

          let error = false;
          self.gl_account_err = '';
          self.gl_amount_err = '';
          self.fiscal_date_error_msg = '';
          self.total_dr_cr_error = '';

          let totalDebitAmount = 0;
          let totalCreditAmount = 0;
          let creditAccountsArr = [];
          let debitAccountsArr = [];

          for(let i = 0;i<self.rows.length;i++) {

            self.rows[i].account_error_msg = "";
            self.rows[i].debit_error_msg = "";
            self.rows[i].credit_error_msg = "";
            self.rows[i].description_error_msg = "";
            self.rows[i].vehicle_error_msg = "";

            if ( self.rows[i].account == null || self.rows[i].account === "" ) {
              self.rows[i].account_error_msg = "GL Account Required.";
              error = true;
            }

            // if ( self.rows[i].debitDisabled === 0 && self.rows[i].creditDisabled === 0 ) {
            //   self.rows[i].debit_error_msg = "Debit Required.";
            //   self.rows[i].credit_error_msg = "Credit Required.";
            //   error = true;
            // }
          }

          // add all required data for journal in row
          for(let i = 0;i<self.rows.length;i++) {
            //credit and debit total if input is not disabled
            // if (self.rows[i].debitDisabled === 0 && self.rows[i].debit.trim() !== "") {
            //   let lineDebitAmt = self.rows[i].debit.replaceAll(",","");
            //   totalDebitAmount += parseFloat(lineDebitAmt);
            // }
            // if (self.rows[i].creditDisabled === 0 && self.rows[i].credit.trim() !== "") {
            //   let lineCreditAmt = self.rows[i].credit.replaceAll(",","");
            //   totalCreditAmount += parseFloat(lineCreditAmt);
            // }
            //
            if ( parseFloat(self.rows[i].debit) !== 0 ) {
              debitAccountsArr.push(self.rows[i].account.value);
            }else {
              creditAccountsArr.push(self.rows[i].account.value);
            }
          }

          if(totalDebitAmount !== totalCreditAmount){
            self.total_dr_cr_error = "Dr and Cr Total is not Matching";
            error = true;
          }

          var fields = $("#journalForm").serializeArray();
          fields.push({name: "type", value: "general"});
          fields.push({name: "gl_src", value: 'A' });
          fields.push({name: "post_date", value: self.post_date});
          fields.push({name: "fiscal_date", value: self.fiscal_date});
          fields.push({name: "header_desc", value:self.header_desc});
          fields.push({name: "from", value: "sip_adjustment"});

          if (self.vehicle_id != null && self.vehicle_id){
            fields.push({name: "vehicle_id", value:self.vehicle_id});
          }

          for(let i = 0;i<self.rows.length;i++) {
            self.rows[i].from = "sip_adjustment";
            self.rows[i].parent_id = self.work_order_id;
            self.rows[i].vehicle_id = self.vehicle_id;
            self.rows[i].woItemId = self.po_number.woItemId;
            self.rows[i].is_capital_cost = 'no';
          }

          fields.push({name: "journalItems", value: JSON.stringify(self.rows)});
          fields.push({ name: "is_reverse", value: 'no' });

          if (!error) {
            self.makeModalDisable()
            $.ajax({
              url: process.env.ROOT_API + "/journal/create",
              type: "POST",
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              cors: true,
              success: function (data) {
                if(data.code === 201){
                  self.$swal('', data.message, 'info');
                  self.makeModalEnable()
                }else{
                  self.loading = false;
                  self.hideModal();
                  self.getSipApglData();
                }
              },
              error: function (jqXHR, exception) {
                self.makeModalEnable()
                self.loading = false;
              },
            });
          }
        },
        getAllPoList: function () {
          const self = this;
          $.ajax({
            url: process.env.ROOT_API + "/workorder/list-all-po",
            type: "GET",
            data: {
              workOrderId: self.work_order_id,
            },
            headers: this.ajxHeaders,
            dataType: "json",
            cors: true,
            success: function (data) {
              data.content.forEach((resData)=>{
                self.poArr.push(
                    {
                      name: resData.po_no,
                      value: resData.vpo_id,
                      woItemId: resData.woItemId
                    }
                );
              });

            },
            error: function (jqXHR, exception) {
              self.loading = false;
            },
          });
        },
    }
};
</script>
<style scoped>
.additionClassTop{
    top: -230px !important;
}
.adjMarginRV{
    margin-right:10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/WorkOrderView.vue